angular.module('ihh-common-web-tpls', ['alert/alert.tpl.html', 'campaign-glance/campaign-glance.tpl.html', 'campaign-messages/campaign-messages.tpl.html', 'campaign-prescriptions/campaign-prescription.tpl.html', 'campaign-prescriptions/campaign-prescriptions.tpl.html', 'campaign-resource-materials/campaign-resource-materials.tpl.html', 'campaigns/campaign-form.tpl.html', 'clinic-plan/clinic-pricing-view.tpl.html', 'episode-template/episode-template.tpl.html', 'episode-type-glance/episode-type-glance.tpl.html', 'file-chooser/file-chooser.tpl.html', 'form/form-update-controls.tpl.html', 'item-chooser/item-chooser.tpl.html', 'item-chooser/item.tpl.html', 'item-chooser/modal-item-chooser.tpl.html', 'item-chooser/thumbnail-row.tpl.html', 'layouts/thumbnail-box.tpl.html', 'navbar/navbar.tpl.html', 'payment-method-entry/payment-method-entry.tpl.html', 'prescription-content/prescription-content-edit.tpl.html', 'prescription-content/prescription-content-view.tpl.html', 'rx-exercise-template/rx-exercise-template.tpl.html', 'scrip-form/scrip-form.tpl.html', 'scrip-template-chooser/protocol-template-item.tpl.html', 'user/change-password.tpl.html', 'user/login.tpl.html', 'user/manage-account.tpl.html', 'user/person.tpl.html', 'user/reset-password.tpl.html', 'user/resolve-person-conflict.tpl.html', 'utilities/modal-about.tpl.html', 'utilities/modal-confirm.tpl.html', 'utilities/modal-exercise-quick-view.tpl.html', 'utilities/modal-notify.tpl.html', 'utilities/modal-text-input.tpl.html', 'utilities/modal-wait.tpl.html', 'utilities/patient-login-wait.tpl.html', 'utilities/ptih-loading.tpl.html', 'utilities/ptih-login-wait.tpl.html', 'view-edit/view-edit-currency.tpl.html', 'view-edit/view-edit-date.tpl.html', 'view-edit/view-edit-media.tpl.html', 'view-edit/view-edit-person.tpl.html', 'view-edit/view-edit-select.tpl.html', 'view-edit/view-edit-tags.tpl.html', 'view-edit/view-edit-text.tpl.html', 'view-edit/view-edit-textarea.tpl.html']);

angular.module('alert/alert.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('alert/alert.tpl.html',
    '<div ng-show="alertMessage.title != \'\' && alertMessage.description != \'\'" ng-class="cssClass" class="alert absolute-alert" role="alert">\n' +
    '  <button type="button" class="close"><span ng-click="hideAlertBanner()">&times;</span></button>\n' +
    '  <div id="alertText">\n' +
    '      <strong>{{alertMessage.title}}</strong> {{alertMessage.description}}\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('campaign-glance/campaign-glance.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('campaign-glance/campaign-glance.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-19 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div tabindex="0" ui-keydown="{\'esc\':\'vm.discardChanges()\'}" class="ihh-md-padding campaign-tab-container">\n' +
    '    <ng-form novalidate name="campaignGlanceForm" role="form" id="campaignGlanceForm">\n' +
    '        <div class="row">\n' +
    '            <div class="col col-sm-9 col-md-10">\n' +
    '                <div class="row">\n' +
    '                    <div class="flex-columns">\n' +
    '                        <ihh-view-edit-text\n' +
    '                            control-id="description"\n' +
    '                            label="Episode Description"\n' +
    '                            edit-flag="vm.isEdit"\n' +
    '                            model="vm.glance.description"\n' +
    '                            model-edit="vm.glanceTemp.description"\n' +
    '                            na-text="None">\n' +
    '                        </ihh-view-edit-text>\n' +
    '                    </div>\n' +
    '                    \n' +
    '                    <div class="flex-columns">\n' +
    '                        <ihh-view-edit-text\n' +
    '                            control-id="goal"\n' +
    '                            label="Episode Goal"\n' +
    '                            edit-flag="vm.isEdit"\n' +
    '                            model="vm.glance.goal"\n' +
    '                            model-edit="vm.glanceTemp.goal"\n' +
    '                            na-text="None">\n' +
    '                        </ihh-view-edit-text>\n' +
    '                    </div>\n' +
    '                    \n' +
    '                    <div class="flex-columns">\n' +
    '                        <div class="form-group">\n' +
    '                            <label class="control-label">Protocol</label>\n' +
    '                            <div class="form-control-static" ng-show="!vm.isEdit">\n' +
    '                                <div ng-show="vm.glance.protocol.name">\n' +
    '                                    {{vm.glance.protocol.name}}\n' +
    '                                </div>\n' +
    '                                <div ng-show="!vm.glance.protocol.name">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div ng-show="vm.isEdit">\n' +
    '                                <div>\n' +
    '                                    <div ng-show="vm.glanceTemp.protocol.name" class="truncate-overflow">\n' +
    '                                        <a href="" ng-click="vm.removeProtocol()">\n' +
    '                                            <span class="glyphicon glyphicon-minus-sign glyphicon-bg-light"></span>\n' +
    '                                        </a>\n' +
    '                                        <span title="{{vm.glanceTemp.protocol.name}}">{{vm.glanceTemp.protocol.name}}</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div ng-show="!vm.glanceTemp.protocol.name">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                                <button type="button" ng-show="vm.isEdit" class="btn btn-primary btn-xs picker-button" ng-click="vm.chooseProtocol()">{{vm.episodeTemp.protocol ? \'Change\' : \'Choose\'}}...</button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    \n' +
    '\n' +
    '                    <div class="col col-xs-12 col-sm-4" ng-if="vm.showEpisodeType()">\n' +
    '                        <ihh-view-edit-select \n' +
    '                            control-id="episode-type" \n' +
    '                            label="Episode Type" \n' +
    '                            edit-flag="vm.isEdit" \n' +
    '                            get="vm.getEpisodeType" \n' +
    '                            set="vm.setEpisodeType" \n' +
    '                            values="vm.getEpisodeTypes()" \n' +
    '                            format-value="vm.formatEpisodeType">\n' +
    '                        </ihh-view-edit-select>\n' +
    '                    </div>\n' +
    '                    \n' +
    '\n' +
    '                    <div ng-if="vm.careGroupConfig" class="flex-columns">\n' +
    '                        <div class="form-group">\n' +
    '                            <label class="control-label">Care Group(s)</label>\n' +
    '                            <div class="form-control-static" ng-show="!vm.isEdit">\n' +
    '                                <div class="picker-indent" ng-repeat="careGroup in vm.glance.careGroups">\n' +
    '                                    {{careGroup.name}}\n' +
    '                                </div>\n' +
    '                                <div ng-if="!vm.glance.careGroups || vm.glance.careGroups.length === 0">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div ng-show="vm.isEdit">\n' +
    '                                <div ng-repeat="careGroup in vm.glanceTemp.careGroups">\n' +
    '                                    <div class="truncate-overflow">\n' +
    '                                        <a href="" ng-click="vm.removeCareGroup(careGroup)">\n' +
    '                                            <span class="glyphicon glyphicon-minus-sign glyphicon-bg-light"></span>\n' +
    '                                        </a>\n' +
    '                                        <span title="{{careGroup.name}}">{{careGroup.name}}</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <button type="button" class="btn btn-primary btn-xs picker-button" ng-click="vm.chooseCareGroup()">Add...</button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    \n' +
    '                    <div class="flex-columns">\n' +
    '                        <ihh-view-edit-select \n' +
    '                            control-id="virtual-visit" \n' +
    '                            label="Virtual Visits" \n' +
    '                            edit-flag="vm.isEdit" \n' +
    '                            get="vm.getVirtualVisitsAllowed" \n' +
    '                            set="vm.setVirtualVisitsAllowed" \n' +
    '                            values="[true, false]" \n' +
    '                            format-value="vm.formatVirtualVisitsAllowed">\n' +
    '                        </ihh-view-edit-select>\n' +
    '                    </div>\n' +
    '                    \n' +
    '                    <div class="flex-columns" ng-if="vm.therapistConfig">\n' +
    '                        <div class="form-group" ng-class="{required: vm.isEdit}">\n' +
    '                            <label class="control-label">{{vm.pageStrings.therapistsAssigned}}</label>\n' +
    '                            <div class="form-control-static" ng-show="!vm.isEdit">\n' +
    '                                <div class="picker-indent" ng-repeat="therapist in vm.glance.therapists">\n' +
    '                                    {{therapist.firstName + \' \' + therapist.lastName}}\n' +
    '                                </div>\n' +
    '                                <div ng-if="vm.glance.therapists.length === 0">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div ng-show="vm.isEdit">\n' +
    '                                <div ng-repeat="therapist in vm.glanceTemp.therapists">\n' +
    '                                    <div class="truncate-overflow">\n' +
    '                                        <a href="" ng-click="vm.removeTherapist(therapist)">\n' +
    '                                            <span class="glyphicon glyphicon-minus-sign glyphicon-bg-light"></span>\n' +
    '                                        </a>\n' +
    '                                        <span title="{{therapist.firstName + \' \' + therapist.lastName}}">{{therapist.firstName + \' \' + therapist.lastName}}</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div ng-if="vm.glanceTemp.therapists.length === 0">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                                <button type="button" class="btn btn-primary btn-xs picker-button" ng-click="vm.chooseTherapist()">Add...</button>\n' +
    '                                <label class="hidden">{{vm.pageStrings.therapistsAssigned}}</label>\n' +
    '                                <input ihh-valid-if="{{vm.glanceTemp.therapists.length > 0}}" type="hidden" id="assignedTherapist" name="assignedTherapist" ng-model="vm.episodeTemp.therapists">\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    \n' +
    '                    <div class="flex-columns" ng-if="vm.associateConfig">\n' +
    '                        <div class="form-group">\n' +
    '                            <label class="control-label">{{vm.pageStrings.associatesAssigned}}</label>\n' +
    '                            <div class="form-control-static" ng-show="!vm.isEdit">\n' +
    '                                <div class="picker-indent" ng-repeat="associate in vm.glance.associates">\n' +
    '                                    {{associate.clinicProfessional.firstName + \' \' + associate.clinicProfessional.lastName}}\n' +
    '                                </div>\n' +
    '                                <div ng-if="!vm.glance.associates || vm.glance.associates.length === 0">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div ng-show="vm.isEdit">\n' +
    '                                <div ng-repeat="associate in vm.glanceTemp.associates">\n' +
    '                                    <div class="truncate-overflow">\n' +
    '                                        <a href="" ng-click="vm.removeAssociate(associate)">\n' +
    '                                            <span class="glyphicon glyphicon-minus-sign glyphicon-bg-light"></span>\n' +
    '                                        </a>\n' +
    '                                        <span title="{{associate.clinicProfessional.firstName + \' \' + associate.clinicProfessional.lastName}}">{{associate.clinicProfessional.firstName + \' \' + associate.clinicProfessional.lastName}}</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div ng-if="vm.glanceTemp.associates.length === 0">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                                <button type="button" class="btn btn-primary btn-xs picker-button" ng-click="vm.chooseAssociate()">Add...</button>\n' +
    '                                <label class="hidden">{{vm.pageStrings.associatesAssigned}}</label>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                \n' +
    '                <episode-type-glance\n' +
    '                    edit-flag="vm.isEdit"\n' +
    '                    episode-object="vm.glance"\n' +
    '                    episode-object-edit="vm.glanceTemp"\n' +
    '                    is-episode-template="true">\n' +
    '                </episode-type-glance>\n' +
    '                \n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </ng-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('campaign-messages/campaign-messages.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('campaign-messages/campaign-messages.tpl.html',
    '<div tabindex="3" ui-keydown="{\'esc\':\'CampaignGlanceVm.cancel()\'}" class="ihh-md-padding campaign-tab-container">\n' +
    '    <ng-form novalidate name="campaignMessagesForm" role="form" id="campaignMessagesForm">\n' +
    '        <div class="row">\n' +
    '            <div class="container" ng-if="!vm.isReadOnly">\n' +
    '                <div class="row">\n' +
    '                    <div class="col-xs-12 col-sm-10 col-sm-offset-1">\n' +
    '                        <div  class="spacer-bottom-very-small">\n' +
    '                            Click the <span class="glyphicon glyphicon-plus-sign" style="color: black;"></span> to select and set an image, video, or voice clip to be sent to a lead or complete the text box and click "Save" to prepare a text message.\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="col-xs-12 col-sm-10 col-sm-offset-1 hidden-xs">\n' +
    '                        <div class="input-group input-group-lg" style="padding: 0px;">\n' +
    '                            <div class="btn-group input-group-addon" style="padding: 3px 12px; background-color: #337AB7; border: 1px solid #2E6DA4;" dropdown>\n' +
    '                                <button type="button" class="btn btn-primary" dropdown-toggle style="color:#fff; background-color:#337AB7; border: none;">\n' +
    '                                    <span class="glyphicon glyphicon-plus-sign"></span>\n' +
    '                                </button>\n' +
    '                                <ul class="dropdown-menu" role="menu">\n' +
    '                                    <li>\n' +
    '                                        <a href="" ng-click="vm.chooseImage()">\n' +
    '                                            <span class="glyphicon glyphicon-picture" style="color: black;"></span> {{vm.templateStrings.sendImage}}\n' +
    '                                        </a>\n' +
    '                                    </li>\n' +
    '                                    <li>\n' +
    '                                        <a href="" ng-click="vm.chooseAudio()">\n' +
    '                                            <span class="glyphicon glyphicon-volume-up" style="color: black;"></span> {{vm.templateStrings.sendVoiceClip}}\n' +
    '                                        </a>\n' +
    '                                    </li>\n' +
    '                                    <li>\n' +
    '                                        <a href="" ng-click="vm.chooseVideo()">\n' +
    '                                            <span class="glyphicon glyphicon-film" style="color: black;"></span> {{vm.templateStrings.sendVideo}}\n' +
    '                                        </a>\n' +
    '                                    </li>\n' +
    '                                </ul>\n' +
    '                            </div>\n' +
    '                            <textarea ihh-focus class="form-control" placeholder="{{vm.templateStrings.newMessage}}" ng-model="vm.newMessage.message"></textarea>\n' +
    '                            <span class="input-group-addon btn btn-primary" style="color: #fff; background-color: #337AB7; border-color: #2E6DA4;" ng-click="vm.sendMessage()">\n' +
    '                                {{vm.templateStrings.send}}\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 col-sm-10 col-sm-offset-1 visible-xs">\n' +
    '                        <div class="input-group input-group-lg" style="padding: 0px;">\n' +
    '                            <textarea ihh-focus class="form-control" placeholder="{{vm.templateStrings.newMessage}}" ng-model="vm.newMessage.message"></textarea>\n' +
    '                            <span class="input-group-addon btn btn-primary" style="color: #fff; background-color: #337AB7; border-color: #2E6DA4;" ng-click="vm.sendMessage()" ng-disabled="!vm.messageHasContent()">\n' +
    '                                {{vm.templateStrings.send}}\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 visible-xs hidden-sm">\n' +
    '                        <div class="btn-group btn-block dropup" style="margin-top: 15px;" dropdown>\n' +
    '                            <button type="button" class="btn btn-lg btn-primary dropdown-toggle col-xs-12" dropdown-toggle>\n' +
    '                                <span class="glyphicon glyphicon-plus-sign"></span>\n' +
    '                                {{vm.templateStrings.sendFile}}\n' +
    '                                <span class="caret"></span>\n' +
    '                            </button>\n' +
    '                            <ul class="dropdown-menu" role="menu">\n' +
    '                                <li>\n' +
    '                                    <a href="" ng-click="vm.chooseImage()">\n' +
    '                                        <span class="glyphicon glyphicon-picture" style="color: black;"></span> {{vm.templateStrings.sendImage}}\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="" ng-click="vm.chooseAudio()">\n' +
    '                                        <span class="glyphicon glyphicon-volume-up" style="color: black;"></span> {{vm.templateStrings.sendVoiceClip}}\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="" ng-click="vm.chooseVideo()">\n' +
    '                                        <span class="glyphicon glyphicon-film" style="color: black;"></span> {{vm.templateStrings.sendVideo}}\n' +
    '                                    </a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div ng-show="vm.messages.length === 0" class="row text-center">\n' +
    '                <div class="col col-xs-12">\n' +
    '                    {{vm.templateStrings.noMessages}}\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div ng-hide="vm.messages.length === 0" class="row" ng-repeat="message in vm.messages| orderBy: \'created\' : true">\n' +
    '                <div class="col col-xs-12" ng-if="!vm.message.isEdit">\n' +
    '                    <div class="hr-text" style="margin-top: 10px;"></div>\n' +
    '                    <div class="col col-xs-7 col-xs-offset-5" style="padding-right: 0px;">\n' +
    '                        <div class="media pull-right">\n' +
    '                            <button class="btn btn-xs btn-danger" style="float:right; margin-left: 2px" ng-if="!vm.isReadOnly"\n' +
    '                                    ng-click="vm.removeMessage(message.id);">\n' +
    '                                <span class="glyphicon glyphicon-trash"></span>\n' +
    '                            </button>\n' +
    '                            <div class="media-right media-top" style="display:inline-block; float:right;">\n' +
    '                                <a ng-if="vm.isReadOnly">\n' +
    '                                    <img class="media-object img-rounded" \n' +
    '                                         style="width: 50px" \n' +
    '                                         ng-src="{{message.sender.thumbnailUrl ? message.sender.thumbnailUrl : vm.getDefaultPersonThumbnailUrl()}}">\n' +
    '                                </a>\n' +
    '                                <a ng-click="vm.changeAuthor(message);" style="cursor: pointer;" ng-if="!vm.isReadOnly">\n' +
    '                                    <img class="media-object img-rounded" \n' +
    '                                         style="width: 50px" \n' +
    '                                         ng-src="{{message.sender.thumbnailUrl ? message.sender.thumbnailUrl : vm.getDefaultPersonThumbnailUrl()}}">\n' +
    '                                </a>\n' +
    '                            </div>\n' +
    '                            <div class="media-body media-middle media-object-border" style="padding: 10px; background-color: rgba(105, 182, 235, 0.75); width: 0%;">\n' +
    '                                <div style="font-size: large;" class="message-text">{{message.message}}</div>\n' +
    '                                <img ng-repeat="name in message.images" class="message-image" ng-src="{{vm.getImageUrl(message, name)}}">\n' +
    '\n' +
    '                                <div class="message-video" ng-repeat="name in message.video">\n' +
    '                                    <ihh-view-edit-media \n' +
    '                                        is-required="false" \n' +
    '                                        is-responsive="false" \n' +
    '                                        edit-flag="false" \n' +
    '                                        model="name" \n' +
    '                                        no-media-url="{{vm.getDefaultVideoThumbnailUrl()}}"\n' +
    '                                        kind="video"\n' +
    '                                        get-media-url="vm.getVideoUrl"\n' +
    '                                        media-url-params="message">\n' +
    '                                    </ihh-view-edit-media>\n' +
    '                                </div>\n' +
    '                                <audio ng-repeat="name in message.audio" controls>\n' +
    '                                    <source ng-src="{{vm.getAudioUrl(message, name)}}">\n' +
    '                                </audio>\n' +
    '                                <div ng-if="message.sender.firstName && message.sender.lastName">\n' +
    '                                    Sender: {{message.sender.lastName}}, {{message.sender.firstName}}\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </ng-form>\n' +
    '</div>');
}]);

angular.module('campaign-prescriptions/campaign-prescription.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('campaign-prescriptions/campaign-prescription.tpl.html',
    '<div class="rx-tabs campaign-prescription">\n' +
    '    <ng-form novalidate name="campaignPrescriptionForm" role="form" id="campaignPrescriptionForm">\n' +
    '        <div class="panel panel-default spacer-top-very-small" ng-style="$last ? {\'margin-bottom\': \'0px\'} : {}">\n' +
    '            <div>\n' +
    '                <div ihh-navbar navbar-styles="naked" \n' +
    '                     brand="{{vm.prescription.name}}" \n' +
    '                     brand-glyphicon="{{vm.prescription._expanded ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'}}" \n' +
    '                     collapse-id="{{vm.prescription.id}}prescribed" \n' +
    '                     on-brand-click="vm.updateExpanded()"\n' +
    '                     has-help="false">\n' +
    '\n' +
    '                    <ul class="nav navbar-nav navbar-right" ng-if="!vm.isReadOnly">\n' +
    '                        <li>\n' +
    '                            <fieldset ng-disabled="vm.disableEditButtons()">\n' +
    '                                <button type="button" class="navbar-btn btn btn-sm btn-primary"\n' +
    '                                        ng-click="vm.edit();"\n' +
    '                                        ng-if="!vm.isEdit">\n' +
    '                                    <span class="glyphicon glyphicon-edit"></span>\n' +
    '                                    Edit\n' +
    '                                </button>\n' +
    '                                <button type="button" class="navbar-btn btn btn-sm btn-danger"\n' +
    '                                        ng-click="vm.remove();"\n' +
    '                                        ng-if="!vm.isEdit && vm.prescription.id">\n' +
    '                                    <span class="glyphicon glyphicon-edit"></span>\n' +
    '                                    Delete\n' +
    '                                </button>\n' +
    '                            </fieldset>\n' +
    '                        </li>\n' +
    '                        <li ng-if="vm.isEdit" class="ihh-form-controls">\n' +
    '                        <ihh-form-controls\n' +
    '                            ihh-form="campaignPrescriptionForm" \n' +
    '                            save-fn="vm.save" \n' +
    '                            cancel-fn="vm.cancel">\n' +
    '                        </ihh-form-controls>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '                <div ng-if="vm.prescription._expanded">\n' +
    '                    <div class="panel-body">\n' +
    '                        <scrip-form\n' +
    '                            enable-expire-after-days="vm.showExpireAfterDays"\n' +
    '                            enable-gamify-sequence="vm.showGamifySequence"\n' +
    '                            edit-flag="vm.isEdit"\n' +
    '                            prescription-object="vm.prescription"\n' +
    '                            prescription-object-edit="vm.rxTemp">\n' +
    '                        </scrip-form>\n' +
    '\n' +
    '                        <div class="pe-no-edit" ng-if="!vm.isEdit">\n' +
    '                            <div class="panel-body prescription-exercises-list" ng-model="vm.prescription.prescriptionExercises">\n' +
    '                                <div ng-repeat="exerciseTemplate in ::vm.prescription.prescriptionExercises">\n' +
    '                                    <div class="col col-xs-12 exercise-container">\n' +
    '                                        <div class="exercise-border">\n' +
    '                                            <img class="thumbnail-left-edit" \n' +
    '                                                 ng-src="{{vm.getExerciseThumbnailUrl(exerciseTemplate)}}">\n' +
    '                                            <div class="row thumbnail-to-left">\n' +
    '                                                <a class="col col-xs-12 pe-split exercise-link" \n' +
    '                                                   ng-class="{\'disabled\' : vm.getExerciseLinkUrl(exerciseTemplate) === null}" \n' +
    '                                                   ng-href="{{vm.getExerciseLinkUrl(exerciseTemplate)}}">\n' +
    '                                                    <div class="exercise-name">\n' +
    '                                                        {{exerciseTemplate.exercise.name ? exerciseTemplate.exercise.name : \'No Name\'}}\n' +
    '                                                    </div>\n' +
    '                                                    <div class="exercise-title">\n' +
    '                                                        {{exerciseTemplate.exercise.title ? exerciseTemplate.exercise.title : \'No Title\'}}\n' +
    '                                                    </div>\n' +
    '                                                </a>\n' +
    '                                                <div class="col col-xs-12 pe-split exercise-details">\n' +
    '                                                    <div class="row-fluid">\n' +
    '                                                        <div ng-if="!exerciseTemplate.exercise.reportOnly">\n' +
    '                                                            <div class="col pe-col">\n' +
    '                                                                <div class="form-group">\n' +
    '                                                                    <label>Sets</label>\n' +
    '                                                                    <div>\n' +
    '                                                                        {{exerciseTemplate.sets|| exerciseTemplate.exercise.sets}}\n' +
    '                                                                    </div>\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                            <div ng-if="vm.displayQuantityType(\'Repetitions\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                                                <div class="col pe-col">\n' +
    '                                                                    <div class="form-group">\n' +
    '                                                                        <label>Reps</label>\n' +
    '                                                                        <div>\n' +
    '                                                                            {{exerciseTemplate.repetitions|| exerciseTemplate.exercise.repetitions}}\n' +
    '                                                                        </div>\n' +
    '                                                                    </div>\n' +
    '                                                                </div>\n' +
    '                                                                <div class="col pe-col">\n' +
    '                                                                    <div class="form-group">\n' +
    '                                                                        <label>Secs/Rep</label>\n' +
    '                                                                        <div>\n' +
    '                                                                            {{exerciseTemplate.secondsPerRep|| exerciseTemplate.exercise.secondsPerRep}}\n' +
    '                                                                        </div>\n' +
    '                                                                    </div>\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                            <div class="col pe-col" ng-if="vm.displayQuantityType(\'Duration\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                                                <div class="form-group">\n' +
    '                                                                    <label>Seconds</label>\n' +
    '                                                                    <div>\n' +
    '                                                                        {{exerciseTemplate.duration|| exerciseTemplate.exercise.duration}}\n' +
    '                                                                    </div>\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                            <div class="col pe-col" ng-if="vm.isMetronome(exerciseTemplate)">\n' +
    '                                                                <div class="form-group">\n' +
    '                                                                    <label>Metronome (bpm)</label>\n' +
    '                                                                    <div>\n' +
    '                                                                        {{vm.getMetronome(exerciseTemplate)}}\n' +
    '                                                                    </div>\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                        </div>\n' +
    '                                                        <div class="col pe-col" ng-if="exerciseTemplate.exercise.resistanceItem">\n' +
    '                                                            <div class="form-group">\n' +
    '                                                                <label>{{exerciseTemplate.resistanceItem.type|| exerciseTemplate.exercise.resistanceItem.type}}</label>\n' +
    '                                                                <div>\n' +
    '                                                                    {{vm.getResistanceItemValue(exerciseTemplate)}}\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                        </div>\n' +
    '                                                    </div>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                                <div class="badge badge-info badge-right-center badge-right-top" ng-if="!exerciseTemplate._expanded && (exerciseTemplate.ttsCuesAndTips || exerciseTemplate.ttsInstructions)">\n' +
    '                                                    <small>TTS</small>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                                <div class="btn-group-vertical btn-group-down-right-stack-down">\n' +
    '                                                    <button type="button" class="btn btn-xs btn-primary" ng-if="exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                                        <span class="text-danger glyphicon glyphicon-chevron-down"></span>\n' +
    '                                                    </button>\n' +
    '                                                    <button type="button" class="btn btn-xs btn-primary" ng-if="!exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                                        <span class="glyphicon glyphicon-chevron-left"></span>\n' +
    '                                                    </button>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '\n' +
    '                                            <div ng-if="exerciseTemplate._expanded">\n' +
    '                                                <div class="row">\n' +
    '                                                    <div class="col col-xs-12" style="margin-top: 15px;">\n' +
    '                                                        <div class="pull-right">\n' +
    '                                                            <span ng-if="exerciseTemplate.ttsInstructions">Text-To-Speech (TTS) Enabled</span>\n' +
    '                                                            <span ng-if="!exerciseTemplate.ttsInstructions">Text-To-Speech (TTS) Disabled</span>\n' +
    '                                                        </div>\n' +
    '\n' +
    '                                                        <div class="form-group">\n' +
    '                                                            <label class="control-label">Instructions</label>\n' +
    '                                                            <div class="pre-whitespace truncate-offset">\n' +
    '                                                                {{exerciseTemplate.instructions|| exerciseTemplate.exercise.instructions}}\n' +
    '                                                            </div>\n' +
    '                                                        </div>                                \n' +
    '                                                    </div>\n' +
    '                                                    <div class="col col-xs-12" style="margin-top: 15px;">\n' +
    '                                                        <div class="pull-right">\n' +
    '                                                            <span ng-if="exerciseTemplate.ttsCuesAndTips">Text-To-Speech (TTS) Enabled</span>\n' +
    '                                                            <span ng-if="!exerciseTemplate.ttsCuesAndTips">Text-To-Speech (TTS) Disabled</span>\n' +
    '                                                        </div>\n' +
    '\n' +
    '                                                        <div class="form-group">\n' +
    '                                                            <label class="control-label">Cues & Tips</label>\n' +
    '                                                            <div class="pre-whitespace truncate-offset">\n' +
    '                                                                {{exerciseTemplate.cuesAndTips|| exerciseTemplate.exercise.cuesAndTips}}\n' +
    '                                                            </div>\n' +
    '                                                        </div>                            \n' +
    '                                                    </div>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="pe-edit prescriptionTemplates" ng-if="vm.isEdit">\n' +
    '                            <div class="panel-body prescription-exercises-list" \n' +
    '                                 as-sortable="vm.sortListeners"\n' +
    '                                 ng-class="{\'dropzone\': vm.isEmptyDropzone()}" \n' +
    '                                 ng-style="vm.isEmptyDropzone() ? {\'margin\': \'15px\'} : {}"\n' +
    '                                 ng-model="vm.rxTemp.prescriptionExercises">\n' +
    '                                <div as-sortable-item \n' +
    '                                     ng-repeat="exerciseTemplate in vm.rxTemp.prescriptionExercises">\n' +
    '                                    <div as-sortable-item-handle class="col col-xs-12 exercise-container">\n' +
    '                                        <div class="exercise-border">\n' +
    '                                            <img class="thumbnail-left-edit" \n' +
    '                                                 ng-src="{{vm.getExerciseThumbnailUrl(exerciseTemplate)}}">\n' +
    '                                            <div class="row thumbnail-to-left">\n' +
    '                                                <a class="col col-xs-12 pe-split exercise-link" \n' +
    '                                                   ng-class="{\'disabled\' : vm.getExerciseLinkUrl(exerciseTemplate, true) === null}" \n' +
    '                                                   ng-href="{{vm.getExerciseLinkUrl(exerciseTemplate, vm.isEdit)}}">\n' +
    '                                                    <div class="exercise-name">\n' +
    '                                                        {{exerciseTemplate.exercise.name ? exerciseTemplate.exercise.name : "No Name"}}\n' +
    '                                                    </div>\n' +
    '                                                    <div class="exercise-title">\n' +
    '                                                        {{exerciseTemplate.exercise.title ? exerciseTemplate.exercise.title : "No Title"}}\n' +
    '                                                    </div>\n' +
    '                                                </a>\n' +
    '\n' +
    '                                                <div class="col col-xs-12 pe-split">\n' +
    '                                                    <div class="row-fluid">\n' +
    '                                                        <div ng-if="!exerciseTemplate.exercise.reportOnly">\n' +
    '                                                            <div class="col pe-col form-group form-group-select">\n' +
    '                                                                <label class="control-label">Units</label>\n' +
    '                                                                <div class="form-control form-control-btn btn-group dropdown-container" dropdown>\n' +
    '                                                                    <button type="button" class="btn btn-primary dropdown-toggle" dropdown-toggle>{{vm.getValueString(vm.getQuantityType(exerciseTemplate))}} <span class="caret"></span></button>\n' +
    '                                                                    <ul class="dropdown-menu" role="menu">\n' +
    '                                                                        <li ng-repeat="quantityType in vm.quantityTypes" ng-click="vm.selectQuantityType(quantityType, exerciseTemplate, prescriptionForm, $event);"><a href="">{{vm.getValueString(quantityType)}}</a></li>\n' +
    '                                                                    </ul>\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                            <div class="col pe-col required form-group">\n' +
    '                                                                <label class="control-label">Sets</label>\n' +
    '                                                                <input type="number" \n' +
    '                                                                       min="0" \n' +
    '                                                                       ng-required="true" \n' +
    '                                                                       class="form-control" \n' +
    '                                                                       ng-model="exerciseTemplate.sets" \n' +
    '                                                                       ihh-valid-if="true"\n' +
    '                                                                       ui-options="{clearOnBlur: false}">\n' +
    '                                                            </div>\n' +
    '\n' +
    '                                                            <div ng-if="vm.displayQuantityType(\'Repetitions\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                                                <div class="col pe-col required form-group">\n' +
    '                                                                    <label class="control-label">Reps</label>\n' +
    '                                                                    <input type="number" \n' +
    '                                                                           min="0" \n' +
    '                                                                           ng-required="true" \n' +
    '                                                                           class="form-control" \n' +
    '                                                                           ng-model="exerciseTemplate.repetitions" \n' +
    '                                                                           ihh-valid-if="true"\n' +
    '                                                                           ui-options="{clearOnBlur: false}">\n' +
    '                                                                </div>\n' +
    '                                                                <div class="col pe-col required form-group">\n' +
    '                                                                    <label class="control-label">Secs/Rep</label>\n' +
    '                                                                    <input type="number" \n' +
    '                                                                           min="0" \n' +
    '                                                                           ng-required="true" \n' +
    '                                                                           class="form-control" \n' +
    '                                                                           ng-model="exerciseTemplate.secondsPerRep" \n' +
    '                                                                           ihh-valid-if="true"\n' +
    '                                                                           ui-options="{clearOnBlur: false}">\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '\n' +
    '                                                            <div ng-if="vm.displayQuantityType(\'Duration\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                                                <div class="col pe-col required form-group">\n' +
    '                                                                    <label class="control-label">Seconds</label>\n' +
    '                                                                    <input type="number" \n' +
    '                                                                           min="0" \n' +
    '                                                                           ng-required="true" \n' +
    '                                                                           class="form-control" \n' +
    '                                                                           ng-model="exerciseTemplate.duration" \n' +
    '                                                                           ihh-valid-if="true"\n' +
    '                                                                           ui-options="{clearOnBlur: false}">\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '\n' +
    '                                                            <div ng-if="vm.isMetronome(exerciseTemplate)" class="col pe-col form-group">\n' +
    '                                                                <label class="control-label">Metronome (bpm)</label>\n' +
    '                                                                <div class="input-group">\n' +
    '                                                                    <input type="number" \n' +
    '                                                                           min="0" \n' +
    '                                                                           ng-required="false" \n' +
    '                                                                           class="form-control" \n' +
    '                                                                           ng-model="exerciseTemplate.metronome" \n' +
    '                                                                           ihh-valid-if="true"\n' +
    '                                                                           ui-options="{clearOnBlur: false}">\n' +
    '                                                                </div>\n' +
    '                                                            </div>\n' +
    '                                                        </div>\n' +
    '\n' +
    '                                                        <ihh-view-edit-select \n' +
    '                                                            ng-if="exerciseTemplate.exercise.resistanceItem"\n' +
    '                                                            class="col pe-col" \n' +
    '                                                            control-id="{{::vm.getControlId(idPrefix, \'ResistanceItemValue\', parentIndex, $id)}}"\n' +
    '                                                            label="{{exerciseTemplate.resistanceItem.type|| exerciseTemplate.exercise.resistanceItem.type}}" \n' +
    '                                                            edit-flag="true" \n' +
    '                                                            containing-model-default="exerciseTemplate.exercise"\n' +
    '                                                            containing-model="exerciseTemplate"\n' +
    '                                                            containing-form="prescriptionForm"\n' +
    '                                                            get="getResistanceItemValue" \n' +
    '                                                            set="setResistanceItemValue" \n' +
    '                                                            values="exerciseTemplate.resistanceItem.resistances"\n' +
    '                                                            values-defaults="exerciseTemplate.exercise.resistanceItem.resistances">\n' +
    '                                                        </ihh-view-edit-select>\n' +
    '                                                    </div>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                                <div class="btn-group-vertical btn-group-up-right-stack-down">\n' +
    '                                                    <button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteExerciseTemplate(exerciseTemplate)">\n' +
    '                                                        <span class="glyphicon glyphicon-trash"></span>\n' +
    '                                                    </button>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                                <div class="badge badge-info badge-right-center" ng-if="!exerciseTemplate._expanded && (exerciseTemplate.ttsCuesAndTips || exerciseTemplate.ttsInstructions)">\n' +
    '                                                    <small>TTS</small>\n' +
    '                                                </div>\n' +
    '\n' +
    '                                                <div class="btn-group-vertical btn-group-down-right-stack-down">\n' +
    '                                                    <button type="button" class="btn btn-xs btn-primary" ng-if="exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                                        <span class="text-danger glyphicon glyphicon-chevron-down"></span>\n' +
    '                                                    </button>\n' +
    '                                                    <button type="button" class="btn btn-xs btn-primary" ng-if="!exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                                        <span class="glyphicon glyphicon-chevron-left"></span>\n' +
    '                                                    </button>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '\n' +
    '                                            <div ng-if="exerciseTemplate._expanded">\n' +
    '                                                <div class="row">\n' +
    '                                                    <div class="col col-xs-12 textarea-view-mode">\n' +
    '                                                        <div class="pull-right">\n' +
    '                                                            <input type="checkbox" ng-model="exerciseTemplate.ttsInstructions">\n' +
    '                                                            <label>Use Text-To-Speech (TTS)</label>\n' +
    '                                                        </div>\n' +
    '\n' +
    '                                                        <div class="form-group">\n' +
    '                                                            <label class="control-label">Instructions</label>\n' +
    '                                                            <textarea rows="4"\n' +
    '                                                                      class="form-control"\n' +
    '                                                                      style="resize: vertical;"\n' +
    '                                                                      focus="false"\n' +
    '                                                                      ng-required="false"\n' +
    '                                                                      ng-model="exerciseTemplate.instructions"\n' +
    '                                                                      ng-change="vm.setTtsInstructions(exerciseTemplate)">\n' +
    '                                                            </textarea>\n' +
    '                                                        </div>                                \n' +
    '                                                    </div>\n' +
    '                                                    <div class="col col-xs-12 textarea-view-mode">\n' +
    '                                                        <div class="pull-right">\n' +
    '                                                            <input type="checkbox" ng-model="exerciseTemplate.ttsCuesAndTips">\n' +
    '                                                            <label>\n' +
    '                                                                Use Text-To-Speech (TTS)\n' +
    '                                                            </label>\n' +
    '                                                        </div>\n' +
    '\n' +
    '                                                        <div class="form-group">\n' +
    '                                                            <label class="control-label">Cues & Tips</label>\n' +
    '                                                            <textarea rows="4"\n' +
    '                                                                      class="form-control"\n' +
    '                                                                      style="resize: vertical;"\n' +
    '                                                                      focus="false"\n' +
    '                                                                      ng-required="false"\n' +
    '                                                                      ng-model="exerciseTemplate.cuesAndTips"\n' +
    '                                                                      ng-change="vm.setTtsCuesAndTips(exerciseTemplate)">\n' +
    '                                                            </textarea>\n' +
    '                                                        </div>\n' +
    '                                                    </div>\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </ng-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('campaign-prescriptions/campaign-prescriptions.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('campaign-prescriptions/campaign-prescriptions.tpl.html',
    '<div tabindex="1" ui-keydown="{\'esc\':\'CampaignGlanceVm.cancel()\'}" class="ihh-md-padding campaign-tab-container campaign-prescriptions">\n' +
    '    <div class="panel-body panel-body-margin-override">\n' +
    '        <div class="row" ng-if="!vm.isReadOnly">\n' +
    '            <div class="col-xs-offset-4 col-xs-4">\n' +
    '                <button type="button" class="btn btn-sm btn-primary btn-block" \n' +
    '                        ng-click="vm.addNewPrescription()"\n' +
    '                        ng-if="vm.canAddNewPrescription()"\n' +
    '                        scroll-on-click>\n' +
    '                    <span class="glyphicon glyphicon-plus-sign"></span>\n' +
    '                    Add New Prescription\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        \n' +
    '        <div class="row">\n' +
    '            <div ng-show="vm.isEdit" class="col-xs-5 chooser-tabs">\n' +
    '                <tabset>\n' +
    '                    <tab heading="{{vm.i18n.exercises}}" active="tabState.campaignExercises" select="setActiveConfig(\'campaignExercises\')">\n' +
    '                        <div class="panel-body">            \n' +
    '                            <ihh-item-chooser config="vm.exercisesConfig">\n' +
    '                                <div ng-if="config.layout === \'grid\'">\n' +
    '                                    <img ng-src="{{item.thumbnailUrl}}" class="img-rounded" draggable="false" width="48">\n' +
    '                                    <div class="exercise-grid-text">\n' +
    '                                        <div ng-show="config.state.sort === \'title\'" title="{{item.title}}">\n' +
    '                                            {{item.title}}\n' +
    '                                        </div>\n' +
    '                                        <div ng-show="config.state.sort !== \'title\'" title="{{item.name}}">\n' +
    '                                            {{item.name}}\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="media" ng-if="config.layout !== \'grid\'">\n' +
    '                                    <div class="media-left media-middle">\n' +
    '                                        <img ng-src="{{item.thumbnailUrl}}" class="media-object img-rounded" draggable="false" width="48">\n' +
    '                                    </div>\n' +
    '                                    <div class="media-body text-left">\n' +
    '                                        <div ng-show="config.state.sort === \'title\'">\n' +
    '                                            <div class="media-heading">\n' +
    '                                                <strong>{{item.title}}</strong>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                        <div ng-show="config.state.sort !== \'title\'"">\n' +
    '                                            <div class="media-heading">\n' +
    '                                                <strong>{{item.name}}</strong>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                        <div ng-show="!item.complete" class="pull-right">\n' +
    '                                            <span class="" style="color: red; font-weight: bold;" title="Draft">Draft</span>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </ihh-item-chooser>\n' +
    '                        </div>  \n' +
    '                    </tab>\n' +
    '\n' +
    '                    <tab heading="Templates" active="tabState.campaignPrescriptionExercises" select="setActiveConfig(\'campaignPrescriptionExercises\')">\n' +
    '                        <div class="panel-body">                    \n' +
    '                            <ihh-item-chooser config="vm.exerciseTemplatesConfig"></ihh-item-chooser> \n' +
    '                        </div>\n' +
    '                    </tab>      \n' +
    '                    <tab heading="Protocol" active="tabState.campaignProtocolExercises" select="setActiveConfig(\'campaignProtocolExercises\')">\n' +
    '                        <div class="panel-body">   \n' +
    '                            <div class="spacer-bottom-very-small">\n' +
    '                                <label class="control-label">Protocol</label>\n' +
    '                                <div>\n' +
    '                                    <div ng-show="vm.episode.protocol.name" class="truncate-overflow">\n' +
    '                                        <a href="" ng-click="vm.removeProtocol(vm.episode.protocol)">\n' +
    '                                            <span class="glyphicon glyphicon-minus-sign glyphicon-bg-light"></span>\n' +
    '                                        </a>\n' +
    '                                        <span title="{{vm.episode.protocol.name}}">{{vm.episode.protocol.name}}</span>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div ng-show="!vm.episode.protocol.name">\n' +
    '                                    None\n' +
    '                                </div>\n' +
    '                                <button type="button" class="btn btn-primary btn-xs picker-button" ng-click="vm.chooseProtocol()">{{vm.episode.protocol ? \'Change\' : \'Choose\'}}...</button>\n' +
    '                            </div>\n' +
    '                            <ihh-item-chooser config="vm.protocolsConfig"></ihh-item-chooser>\n' +
    '                        </div>\n' +
    '                    </tab>\n' +
    '                </tabset>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-class="vm.isEdit ? \'col col-xs-7\' : \'col col-xs-12\'"\n' +
    '                fullscreen-height \n' +
    '                fullscreen-height-edit-flag="vm.isEdit">\n' +
    '                <div class="row" ng-repeat="prescription in vm.prescriptions track by $index">\n' +
    '                    <campaign-prescription \n' +
    '                        clinic="vm.clinic"\n' +
    '                        therapist-id="vm.therapistId"\n' +
    '                        prescriptions-crud="vm.prescriptionsCrud"\n' +
    '                        episode-model="vm.episodeModel"\n' +
    '                        prescription="prescription"\n' +
    '                        index="$index"\n' +
    '                        has-clinic-feature="vm.hasClinicFeature"\n' +
    '                        is-read-only="vm.isReadOnly">\n' +
    '                    </campaign-prescription>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('campaign-resource-materials/campaign-resource-materials.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('campaign-resource-materials/campaign-resource-materials.tpl.html',
    '<div tabindex="2" ui-keydown="{\'esc\':\'CampaignGlanceVm.cancel()\'}" class="ihh-md-padding campaign-tab-container">\n' +
    '    <ng-form novalidate name="campaignResourceMaterialsForm" role="form" id="campaignResourceMaterialsForm">\n' +
    '        <div class="panel-body panel-body-margin-override">\n' +
    '            <div class="row" ng-if="!vm.isReadOnly">\n' +
    '                <div class="col-xs-offset-4 col-xs-4">\n' +
    '                    <button type="button" class="btn btn-sm btn-primary btn-block" \n' +
    '                            ng-click="vm.chooseResourceMaterial()"\n' +
    '                            scroll-on-click>\n' +
    '                        <span class="glyphicon glyphicon-plus-sign"></span>\n' +
    '                        {{vm.templateStrings.addResource}}\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-show="!vm.resources.length && !vm.resources.length" class="row text-center">\n' +
    '                <div class="col col-xs-12">\n' +
    '                    {{vm.templateStrings.noResources}}\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="pe-no-edit">\n' +
    '                <div class="panel-body resources-list ng-pristine ng-untouched ng-valid" ng-model="vm.resources">\n' +
    '                    <div ng-repeat="item in vm.resources">\n' +
    '                        <div class="col col-xs-12 resource-container">\n' +
    '                            <div class="pull-left thumbnail-left-edit resource-thumbnail-container">\n' +
    '                                <img ng-src="{{vm.getResourceMaterialThumbnailUrl(item.resourceMaterial)}}" ng-class="{\'default-resource-thumbnail default-resource-thumbnail-margin\': !item.resourceMaterial.thumbnail, \'resource-thumbnail\': item.resourceMaterial.thumbnail}">\n' +
    '                                <div class="thumbnail-caption" ng-class="{\'thumbnail-caption-offset\': item.resourceMaterial.thumbnail}">\n' +
    '                                    {{item.resourceMaterial.typeLabel}}\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="thumbnail-to-left resource-text">\n' +
    '                                <a ng-if="item.resourceMaterial.mediaType === \'application/pdf\'" class="col col-xs-6 resource-link" ng-href="{{vm.getMediaUrl(item.resourceMaterial)}}" target="_blank">\n' +
    '                                    <div class="resource-name ng-binding">\n' +
    '                                        {{item.resourceMaterial.name}}\n' +
    '                                    </div>\n' +
    '                                    <div class="resource-title ng-binding">\n' +
    '                                        {{item.resourceMaterial.title}}\n' +
    '                                    </div>\n' +
    '                                </a>\n' +
    '                                <a ng-if="item.resourceMaterial.url" class="col col-xs-6 resource-link" ng-href="{{vm.getUrl(item.resourceMaterial.url)}}" target="_blank">\n' +
    '                                    <div class="resource-name ng-binding">\n' +
    '                                        {{item.resourceMaterial.name}}\n' +
    '                                    </div>\n' +
    '                                    <div class="resource-title ng-binding">\n' +
    '                                        {{item.resourceMaterial.title}}\n' +
    '                                    </div>\n' +
    '                                </a>\n' +
    '                                <a ng-if="item.resourceMaterial.mediaType === \'video/mp4\'" class="col col-xs-6 resource-link" ng-click="vm.displayVideoPreview($event, item)" target="_blank">\n' +
    '                                    <div class="resource-name ng-binding">\n' +
    '                                        {{item.resourceMaterial.name}}\n' +
    '                                    </div>\n' +
    '                                    <div class="resource-title ng-binding">\n' +
    '                                        {{item.resourceMaterial.title}}\n' +
    '                                    </div>\n' +
    '                                </a>\n' +
    '                                <div class="btn-group-vertical btn-group-up-right-stack-down" ng-if="!vm.isReadOnly">\n' +
    '                                    <button type="button" class="btn btn-xs btn-danger" ng-click="vm.removeEpisodeResourceMaterial(item)">\n' +
    '                                        <span class="glyphicon glyphicon-trash"></span>\n' +
    '                                    </button>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </ng-form>\n' +
    '</div>');
}]);

angular.module('campaigns/campaign-form.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('campaigns/campaign-form.tpl.html',
    '<!--\n' +
    'Copyright (c) 2019 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="row">\n' +
    '    <div class="col col-sm-9 col-md-10">\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12 col-sm-6">\n' +
    '                <ihh-view-edit-text\n' +
    '                    control-id="name"\n' +
    '                    label="Name"\n' +
    '                    is-required="true"\n' +
    '                    edit-flag="vm.editFlag"\n' +
    '                    model="vm.state.campaign.name"\n' +
    '                    model-edit="vm.state.campaignTemp.name">\n' +
    '                </ihh-view-edit-text>\n' +
    '            </div>\n' +
    '            <div class="col col-xs-12 col-sm-6" ng-if="vm.editFlag">\n' +
    '                <ihh-view-edit-select\n' +
    '                    control-id="status" \n' +
    '                    label="Status" \n' +
    '                    edit-flag="vm.editFlag" \n' +
    '                    get="vm.getStatus" \n' +
    '                    set="vm.setStatus" \n' +
    '                    values="vm.statuses">\n' +
    '                </ihh-view-edit-select>\n' +
    '            </div>\n' +
    '            <div class="col col-xs-12 col-sm-6" ng-if="!vm.editFlag">\n' +
    '                <label>Status</label>\n' +
    '                <div>{{vm.getStatus()}}</div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12 col-sm-6">\n' +
    '                <ihh-view-edit-text\n' +
    '                    control-id="description"\n' +
    '                    label="Description"\n' +
    '                    is-required="true"\n' +
    '                    edit-flag="vm.editFlag"\n' +
    '                    model="vm.state.campaign.description"\n' +
    '                    model-edit="vm.state.campaignTemp.description">\n' +
    '                </ihh-view-edit-text>\n' +
    '            </div>\n' +
    '            <div class="col col-xs-12 col-sm-6" ng-if="!vm.isTemplate">\n' +
    '                <ihh-view-edit-select\n' +
    '                    control-id="clinicGroupShared" \n' +
    '                    label="Shared with Clinic Group" \n' +
    '                    edit-flag="vm.editFlag" \n' +
    '                    get="vm.getClinicGroupShared" \n' +
    '                    set="vm.setClinicGroupShared" \n' +
    '                    values="vm.clinicGroupSharedValues" \n' +
    '                    format-value="vm.formatYesNo">\n' +
    '                </ihh-view-edit-select>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="horz-spacer"></div>\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12 strong">Lead Generation (Optional)</div>\n' +
    '        </div>\n' +
    '        <div class="horz-spacer"></div>\n' +
    '        <div class="horz-spacer"></div>\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12 col-sm-6" ng-if="!vm.isTemplate">\n' +
    '                <ihh-view-edit-text\n' +
    '                    control-id="code"\n' +
    '                    label="Code"\n' +
    '                    is-required="false"\n' +
    '                    edit-flag="vm.editFlag"\n' +
    '                    model="vm.state.campaign.code"\n' +
    '                    model-edit="vm.state.campaignTemp.code">\n' +
    '                </ihh-view-edit-text>\n' +
    '            </div>\n' +
    '            <div class="col col-xs-12 col-sm-6">\n' +
    '                <ihh-view-edit-text\n' +
    '                    control-id="maximum-enrollments"\n' +
    '                    label="Maximum Enrollments"\n' +
    '                    text-type="number"\n' +
    '                    is-required="false"\n' +
    '                    edit-flag="vm.editFlag"\n' +
    '                    model="vm.state.campaign.maximumEnrollments"\n' +
    '                    model-edit="vm.state.campaignTemp.maximumEnrollments">\n' +
    '                </ihh-view-edit-text>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="vm.isTemplate">\n' +
    '            <div class="col col-xs-12 col-sm-6 form-group">\n' +
    '                <label class="control-label">Clinic Specialties(s)</label>\n' +
    '                <div class="form-control-static" ng-show="!vm.editFlag">\n' +
    '                    <div ng-if="vm.state.campaign.clinicSpecialties.length">\n' +
    '                        <div class="picker-indent" ng-repeat="clinicSpecialty in vm.state.campaign.clinicSpecialties">\n' +
    '                            {{clinicSpecialty.name}}\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="!vm.state.campaign.clinicSpecialties.length" class="picker-indent">\n' +
    '                        None\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div ng-show="vm.editFlag">\n' +
    '                    <div ng-repeat="clinicSpecialty in vm.state.campaignTemp.clinicSpecialties">\n' +
    '                        <div class="truncate-overflow">\n' +
    '                            <a href="" ng-click="vm.removeClinicSpecialty(clinicSpecialty)">\n' +
    '                                <span class="glyphicon glyphicon-minus-sign glyphicon-bg-light"></span>\n' +
    '                            </a>\n' +
    '                            <span title="{{clinicSpecialty.name}}">{{clinicSpecialty.name}}</span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <button type="button" class="btn btn-primary btn-xs picker-button" ng-click="vm.chooseClinicSpecialty()">Add...</button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('clinic-plan/clinic-pricing-view.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('clinic-plan/clinic-pricing-view.tpl.html',
    '<span ng-if="price >= 0">{{price | currency: "$" : 2}} Paid {{paidLabel}}</span>\n' +
    '<span ng-if="!(price >= 0)">No {{priceLabel}} Price Set</span>');
}]);

angular.module('episode-template/episode-template.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('episode-template/episode-template.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-16 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '\n' +
    '<div class="spacer-top-very-small episode" cg-busy="vm.episodeTemplateFormPromise">\n' +
    '    <ng-form novalidate name="episodeTemplateForm" role="form" id="episodeTemplateForm">\n' +
    '        <div ihh-navbar navbar-styles="naked" brand="{{vm.episodeModel.description}}" brand-glyphicon="{{vm._expanded ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'}}" collapse-id="episode-{{$index}}-navbar-id" has-collapsible="true" has-help="false" on-brand-click="vm.toggleCollapsed();">\n' +
    '            <ul class="nav navbar-nav navbar-right">\n' +
    '                <li ng-if="!vm.isReadOnly && vm.isSelectedTab(vm.TABS.glance)" ng-show="!vm.isReadOnly">\n' +
    '                    <button type="button" class="navbar-btn btn btn-sm btn-primary" \n' +
    '                            ng-show="!vm.isEdit" \n' +
    '                            ng-click="vm.edit()">\n' +
    '                        <span class="glyphicon glyphicon-edit"></span>\n' +
    '                        Edit\n' +
    '                    </button>\n' +
    '                    <button type="button" class="navbar-btn btn btn-sm btn-danger"\n' +
    '                            ng-show="!vm.isEdit && vm.episodeModel.id"\n' +
    '                            ng-click="vm.remove()">\n' +
    '                        <span class="glypicon glypicon-trash"></span>\n' +
    '                        Delete\n' +
    '                    </button>\n' +
    '                    <ihh-form-controls\n' +
    '                        ng-show="vm.isEdit"\n' +
    '                        ihh-form="episodeTemplateForm" \n' +
    '                        ihh-form-ignores="vm.ihhFormIgnores"\n' +
    '                        inner-nav="true"\n' +
    '                        save-fn="vm.save"\n' +
    '                        cancel-fn="vm.cancel">\n' +
    '                    </ihh-form-controls>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '\n' +
    '        <tabset cg-busy="vm.episodeTemplatePromise" class="patient-tabset" ng-if="vm._expanded">\n' +
    '            <tab heading="Glance" active="vm.tabState.glance" select="vm.setSelectedTab(vm.TABS.glance)" disable="vm.isEdit">\n' +
    '                <div ng-if="vm.isSelectedTab(vm.TABS.glance)">\n' +
    '                    <campaign-glance \n' +
    '                        clinic="vm.clinic"\n' +
    '                        save-episode-template="vm.saveEpisodeTemplate"\n' +
    '                        update-episode-template="vm.updateEpisodeTemplate"\n' +
    '                        remove-episode-template="vm.removeEpisodeTemplate"\n' +
    '                        therapist-config="vm.therapistConfig"\n' +
    '                        associate-config="vm.associateConfig"\n' +
    '                        care-group-config="vm.careGroupConfig"\n' +
    '                        prescriptions-crud="vm.prescriptionsCrud"\n' +
    '                        episode-model="vm.episodeModel"/>\n' +
    '                </div>\n' +
    '            </tab>\n' +
    '            <tab heading="Prescriptions" active="vm.tabState.prescription" select="vm.setSelectedTab(vm.TABS.prescription)" disable="vm.isEdit" ng-if="!vm.isNew">\n' +
    '                <div ng-if="vm.isSelectedTab(vm.TABS.prescription)">\n' +
    '                    <campaign-prescriptions\n' +
    '                        clinic="vm.clinic"\n' +
    '                        therapist-id="vm.therapistId"\n' +
    '                        prescriptions-crud="vm.prescriptionsCrud"\n' +
    '                        exercises-config="vm.exercisesConfig"\n' +
    '                        exercise-templates-config="vm.exerciseTemplatesConfig"\n' +
    '                        protocols-config="vm.protocolsConfig"\n' +
    '                        episode-model="vm.episodeModel"\n' +
    '                        is-read-only="vm.isReadOnly"\n' +
    '                        has-clinic-feature="vm.hasClinicFeature"/>\n' +
    '                </div>\n' +
    '            </tab>\n' +
    '            <tab heading="Resources" active="vm.tabState.resourceMaterials" select="vm.setSelectedTab(vm.TABS.resourceMaterials)" disable="vm.isEdit" ng-if="!vm.isNew">\n' +
    '                <div ng-if="vm.isSelectedTab(vm.TABS.resourceMaterials)">\n' +
    '                    <campaign-resource-material \n' +
    '                        clinic="vm.clinic"\n' +
    '                        resource-materials-crud="vm.resourceMaterialsCrud"\n' +
    '                        resource-materials-config="vm.resourceMaterialsConfig"\n' +
    '                        episode-model="vm.episodeModel"\n' +
    '                        is-read-only="vm.isReadOnly"/>\n' +
    '                </div>\n' +
    '            </tab>\n' +
    '            <tab heading="Messages" active="vm.tabState.messages" select="vm.setSelectedTab(vm.TABS.messages)" disable="vm.isEdit" ng-if="!vm.isNew">\n' +
    '                <div ng-if="vm.isSelectedTab(vm.TABS.messages)">\n' +
    '                    <campaign-messages \n' +
    '                        clinic="vm.clinic"\n' +
    '                        therapist-id="vm.therapistId"\n' +
    '                        therapist-config="vm.therapistConfig"\n' +
    '                        messages-crud="vm.messagesCrud"\n' +
    '                        episode-model="vm.episodeModel"\n' +
    '                        is-read-only="vm.isReadOnly"/>\n' +
    '                </div>\n' +
    '            </tab>\n' +
    '        </tabset>\n' +
    '    </ng-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('episode-type-glance/episode-type-glance.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('episode-type-glance/episode-type-glance.tpl.html',
    '<!--\n' +
    'Copyright (c) 2019-20 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div ng-if="vm.episodeObject.type.workflow">\n' +
    '    <hr class="separator">\n' +
    '    <div class="row display-flex">\n' +
    '        <div class="col col-xs-12 col-sm-4" ng-repeat="attr in vm.episodeObject.type.workflow.attributes">\n' +
    '            <div ng-if="attr.type == \'string\' || attr.type == \'int\'">\n' +
    '                <ihh-view-edit-text ng-if="!attr.choices"\n' +
    '                                    control-id="{{\'custom-attr-\' + attr.id}}"\n' +
    '                                    label="{{vm.editFlag ? attr && (attr.editPrompt || attr.name) : (attr && attr.name)}}"\n' +
    '                                    edit-flag="vm.editFlag"\n' +
    '                                    model="vm.episodeObject.customValues[attr.id]"\n' +
    '                                    model-edit="vm.episodeObjectEdit.customValues[attr.id]"\n' +
    '                                    text-type="{{vm.getAttributeTextType(attr)}}"\n' +
    '                                    na-text="N/A">\n' +
    '                </ihh-view-edit-text>\n' +
    '                <ihh-view-edit-select ng-if="attr.choices"\n' +
    '                                    control-id="{{\'custom-attr-\' + attr.id}}" \n' +
    '                                    label="{{vm.editFlag ? attr && (attr.editPrompt || attr.name) : (attr && attr.name)}}"\n' +
    '                                    edit-flag="vm.editFlag" \n' +
    '                                    containing-model="attr"\n' +
    '                                    get="vm.getAttribute" \n' +
    '                                    set="vm.setAttribute" \n' +
    '                                    values="attr.choices">\n' +
    '                </ihh-view-edit-select>\n' +
    '            </div>\n' +
    '            <div ng-if="attr.type == \'date\'">\n' +
    '                <ihh-view-edit-date\n' +
    '                    control-id="{{\'custom-attr-\' + attr.id}}" \n' +
    '                    label="{{vm.editFlag ? attr && (attr.editPrompt || attr.name) : (attr && attr.name)}}"\n' +
    '                    model="vm.getSetDateAttribute(attr)"\n' +
    '                    model-edit="vm.getSetDateAttribute(attr)"\n' +
    '                    is-model-getter-setter="true"\n' +
    '                    is-edit="vm.editFlag"\n' +
    '                    is-open="isBirthCalendarOpen" \n' +
    '                    max-date="today"\n' +
    '                    show-time="false"\n' +
    '                    display-format="mediumDate"\n' +
    '                    time-zone="UTC"\n' +
    '                    >\n' +
    '                </ihh-view-edit-date>\n' +
    '            </div>\n' +
    '            <div ng-if="attr.type == \'age\'">\n' +
    '                <ihh-view-edit-text ng-if="!vm.editFlag"\n' +
    '                    control-id="{{\'custom-attr-\' + attr.id}}"\n' +
    '                    label="{{vm.editFlag ? attr && (attr.editPrompt || attr.name) : (attr && attr.name)}}"\n' +
    '                    edit-flag="vm.editFlag"\n' +
    '                    model="vm.getAgeFromDateAttribute(attr)"\n' +
    '                    model-edit="null"\n' +
    '                    text-type="number"\n' +
    '                    na-text="N/A"\n' +
    '                    zero-is-set="true">\n' +
    '                </ihh-view-edit-text>\n' +
    '                <ihh-view-edit-date ng-if="vm.editFlag"\n' +
    '                    control-id="{{\'custom-attr-\' + attr.id}}" \n' +
    '                    label="{{vm.editFlag ? attr && (attr.editPrompt || attr.name) : (attr && attr.name)}}"\n' +
    '                    model="null"\n' +
    '                    model-edit="vm.getSetDateAttribute(attr)"\n' +
    '                    is-model-getter-setter="true"\n' +
    '                    is-edit="vm.editFlag"\n' +
    '                    is-open="isBirthCalendarOpen" \n' +
    '                    max-date="today"\n' +
    '                    show-time="false"\n' +
    '                    time-zone="UTC">\n' +
    '                </ihh-view-edit-date>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="vm.episodeObject.workflowTrigger" class="col col-xs-12 col-sm-4">\n' +
    '            <ihh-view-edit-text\n' +
    '                control-id="{{\'scrip\' + vm.episodeObject.workflowTrigger.id}}"\n' +
    '                secondary-label="(frequency in days)"\n' +
    '                label="{{vm.episodeObject.workflowTrigger.name}}"\n' +
    '                edit-flag="vm.editFlag"\n' +
    '                model="vm.episodeObject.workflowTrigger._frequencyDays"\n' +
    '                model-edit="vm.episodeObject.workflowTrigger._frequencyDaysTemp"\n' +
    '                text-type="numeric"\n' +
    '                na-text="N/A">\n' +
    '            </ihh-view-edit-text>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="vm.trackedMeasureRec && !vm.isEpisodeTemplate" class="col col-xs-12 col-sm-4">\n' +
    '            <ihh-view-edit-select\n' +
    '                control-id="tracked-measure" \n' +
    '                label="{{vm.trackedMeasureRec.description}}" \n' +
    '                edit-flag="vm.editFlag" \n' +
    '                containing-model="vm.trackedMeasureRec"\n' +
    '                get="vm.getMeasure" \n' +
    '                set="vm.setMeasure" \n' +
    '                values="vm.trackedMeasureRec.choices">\n' +
    '            </ihh-view-edit-select>\n' +
    '        </div>\n' +
    '\n' +
    '        <ihh-view-edit-text ng-if="vm.nextChangeMeasureRec && vm.episodeObject.workflowTrigger && !vm.isEpisodeTemplate" class="col col-xs-12 col-sm-4"\n' +
    '                control-id="exercise-days"\n' +
    '                label="{{vm.nextChangeMeasureRec.description}}"\n' +
    '                edit-flag="vm.editFlag"\n' +
    '                model="vm.episodeObject.workflowTrigger._nextExerciseDay"\n' +
    '                model-edit="vm.episodeObject.workflowTrigger._nextExerciseDayTemp"\n' +
    '                view-format-fn="vm.formatNextExerciseDay"\n' +
    '                text-type="numeric"\n' +
    '                na-text="N/A"\n' +
    '                zero-is-set="true">\n' +
    '        </ihh-view-edit-text>\n' +
    '\n' +
    '        <ihh-view-edit-text ng-if="vm.completedMeasureRec && !vm.isEpisodeTemplate" class="col col-xs-12 col-sm-4"\n' +
    '                            control-id="completed-measure"\n' +
    '                            label="{{vm.completedMeasureRec.description}}"\n' +
    '                            edit-flag="false"\n' +
    '                            model="vm.getFutureDateMeasure(vm.completedMeasureRec)"\n' +
    '                            na-text="N/A"\n' +
    '                            zero-is-set="true">\n' +
    '        </ihh-view-edit-text>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('file-chooser/file-chooser.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('file-chooser/file-chooser.tpl.html',
    '<form>\n' +
    '    <div class="modal-header">\n' +
    '        <button type="button" class="close" ng-click="cancel()">\n' +
    '            <span class="glyphicon glyphicon-remove" style="padding-left: 0px;"></span>\n' +
    '        </button>\n' +
    '        <h4 class="modal-title" style="font-family: sans-serif; font-size: 18px; color: #555;">\n' +
    '            <span class="glyphicon glyphicon-user" ng-show="mediaType === \'thumbnail\'" style="color: #555;"></span>\n' +
    '            <span class="glyphicon glyphicon-picture" ng-show="mediaType === \'image\'" style="color: #555;"></span>\n' +
    '            <span class="glyphicon glyphicon-film" ng-show="mediaType === \'video\'" style="color: #555;"></span>\n' +
    '            <span class="glyphicon glyphicon-music" ng-show="mediaType === \'audio\'" style="color: #555;"></span>\n' +
    '            {{title}}\n' +
    '        </h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body" stop-event="touchend">\n' +
    '        <p>{{message}}</p>\n' +
    '        <p ng-hide="mediaType !== \'thumbnail\'">\n' +
    '            <span style="font-weight: bold;">Recommended:</span>\n' +
    '            JPG, GIF, or PNG format. You will be able to crop the image after uploading to a final size of 150x150 pixels.\n' +
    '        </p>\n' +
    '        <div>\n' +
    '            <input type="file" data-file-model="pickedFile" onchange="angular.element(this).scope().onFile(this.files[0])" accept="{{fileType}}"/>\n' +
    '            <div class="horz-spacer"></div>\n' +
    '            <button ng-hide="!pickedFile || !(mediaType === \'image\' || mediaType === \'thumbnail\')" ng-click="togglePreview()">\n' +
    '                <span ng-show="!showPreview">Show preview</span>\n' +
    '                <span ng-show="showPreview">Edit</span>\n' +
    '            </button>\n' +
    '            <button ng-hide="!pickedFile || !(mediaType === \'image\' || mediaType === \'thumbnail\') || showPreview" ng-click="rotate()">\n' +
    '                <span>Rotate</span>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '        <div ng-if="dataUrl" class="" ng-show="!showPreview && (mediaType === \'image\' || mediaType === \'thumbnail\')">\n' +
    '            <img ng-if="dataUrl" ng-src="{{dataUrl}}" class="img-responsive"\n' +
    '                 ng-cropper\n' +
    '                 ng-cropper-proxy="cropperProxy"\n' +
    '                 ng-cropper-show="showEvent"\n' +
    '                 ng-cropper-hide="hideEvent"\n' +
    '                 ng-cropper-options="options">\n' +
    '        </div>\n' +
    '        <div class="" ng-show="showPreview && (mediaType === \'image\' || mediaType === \'thumbnail\')">\n' +
    '            <img ng-if="preview.dataUrl" ng-src="{{preview.dataUrl}}" class="img-responsive">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-show="badFile" class="alert alert-danger text-center spacer-bottom-none">\n' +
    '        File is not of the appropriate type.\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" class="btn btn-primary" ng-disabled="!pickedFile || badFile" ng-click="ok(pickedFile)" ihh-focus="{{!!pickedFile}}">\n' +
    '            <span class="glyphicon glyphicon-ok-sign" style=""></span>\n' +
    '            OK\n' +
    '        </button>\n' +
    '        <button type="button" class="btn btn-default" ng-click="cancel()">\n' +
    '            <span class="glyphicon glyphicon-remove-sign" style="color: #555;"></span>\n' +
    '            Cancel\n' +
    '        </button>\n' +
    '    </div>\n' +
    '</form>');
}]);

angular.module('form/form-update-controls.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('form/form-update-controls.tpl.html',
    '<button type="button" ng-class="innerNav ? \'navbar-btn btn btn-sm btn-primary\' : \'btn btn-sm btn-primary\'" \n' +
    '        ng-disabled="(prescriptionForm && !isExpanded)"\n' +
    '        ng-click="saveSequence(ihhForm, saveFn, prescriptionForm)">\n' +
    '    <span class="glyphicon" ng-class="saveGlyphiconClass"></span>\n' +
    '    {{saveFnLabel}}\n' +
    '</button>\n' +
    '<button ng-if="saveAndNewFn" type="button" ng-class="innerNav ? \'navbar-btn btn btn-sm btn-primary\' : \'btn btn-sm btn-primary\'" \n' +
    '        ng-disabled="(prescriptionForm && !isExpanded)"\n' +
    '        ng-click="saveSequence(ihhForm, saveAndNewFn, prescriptionForm)">\n' +
    '    <span class="glyphicon glyphicon-floppy-disk"></span>\n' +
    '    Save & New\n' +
    '</button>\n' +
    '<button type="button" ng-class="innerNav ? \'navbar-btn btn btn-sm btn-default\' : \'btn btn-sm btn-default\'"\n' +
    '        ng-click="cancelSequence(ihhForm, cancelFn, prescriptionForm)">\n' +
    '    <span class="glyphicon glyphicon-bg-light glyphicon-remove-sign"></span>\n' +
    '    {{cancelFnLabel}}\n' +
    '</button>');
}]);

angular.module('item-chooser/item-chooser.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('item-chooser/item-chooser.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="item-chooser-container">\n' +
    '    <div class="row">\n' +
    '        <div class="col col-xs-3 item-chooser-reset" ng-if="(!config.showRefresh && (config.searchable || (config.filterOptions && config.filterOptions.length > 0)))">\n' +
    '            <a type="button" class="anchor-link" ng-click="config.clearAll()">Clear all</a>\n' +
    '        </div>\n' +
    '        <div class="col col-xs-3 item-chooser-reset" ng-if="(config.showRefresh)">\n' +
    '            <button type="button" class="btn btn-sm btn-primary" ng-click="config.clearResume(true)">Refresh</button>\n' +
    '        </div>\n' +
    '        <div class="col item-chooser-who" ng-class="(!config.searchable && (!config.filterOptions || config.filterOptions.length <= 0)) ? \'col-xs-12\' : \'col-xs-9\'" ng-if="config.who">\n' +
    '            <div ng-show="config.who.length > 1" class="text-center">\n' +
    '                <span ng-repeat="whom in config.who track by $index">\n' +
    '                    <label style="padding-right: 15px" ng-class="{radioseparator: $index > 0 && config.who[$index - 1].group !== whom.group}">\n' +
    '                        <input type="radio" ng-model="config.state.whose" ng-value="whom.id" ng-change="config.clearResume()">\n' +
    '                        {{whom.label}}\n' +
    '                    </label>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row item-chooser-search" ng-if="config.searchable">\n' +
    '        <div class="col-xs-12" style="margin-top: -8px; margin-bottom: 5px;">\n' +
    '            <div class="text-center">\n' +
    '                <div class="input-group">\n' +
    '                    <input type="text" class="form-control spacer-bottom-small input-sm" ng-class="{\'has-search\': (config.state.searchedTerms.length > 0), \'has-pending-search\': (config.state.searchedTerms !== config.state.searchTerms)}" ng-model="config.state.searchTerms" placeholder="Search {{config.itemProperties.name.plural}}" ng-change="config.searchChange(config.state.searchTerms)"  ui-keydown="{\'enter\':\'config.search()\'}">\n' +
    '                    <span class="input-group-btn">\n' +
    '                        <button type="button" class="btn btn-sm btn-primary" ng-click="config.search()">Search</button>\n' +
    '                    </span>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row item-chooser-overhead" ng-if="config.isShowOverheadSort() || config.isShowOverheadFilter()">\n' +
    '        <div ng-if="config.isShowOverheadSort()" ng-class="{\'col-xs-12\': !config.isShowOverheadFilter(), \'col-xs-6\': config.isShowOverheadFilter()}">\n' +
    '            <div style="background-color: lightgrey; border-radius: 4px; padding: 5px; margin-bottom: 10px;">\n' +
    '                <label>Sort By</label>\n' +
    '                <div class="btn-group" style="max-width: 100%" dropdown>\n' +
    '                    <button type="button" class="btn btn-primary dropdown-toggle chooser-dropdown" dropdown-toggle>\n' +
    '                        <span ng-style="config.getSortLabelStyle()">{{config.getSortLabel().option}}</span> <span>{{config.getSortLabel().direction}}</span><span class="caret"></span>\n' +
    '                    </button>\n' +
    '                    <ul class="dropdown-menu" role="menu">\n' +
    '                        <li ng-repeat-start="option in config.sortOptions| orderBy:\'label\'" ng-click="config.setSort(option, false); closeDropdown($event);" ng-show="config.isShowSort(option, false)">\n' +
    '                            <a href=""><span ng-style="option.labelStyle">{{option.label}}</span> {{config.getSortKindLabel(option, false)}}</a>\n' +
    '                        </li>\n' +
    '                        <li ng-repeat-end ng-click="config.setSort(option, true); closeDropdown($event);" ng-show="config.isShowSort(option, true)">\n' +
    '                            <a href=""><span ng-style="option.labelStyle">{{option.label}}</span> {{config.getSortKindLabel(option, true)}}</a>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="config.isShowOverheadFilter()" ng-class="{\'col-xs-12\': !config.isShowOverheadSort(), \'col-xs-6\': config.isShowOverheadSort()}">\n' +
    '            <div ng-show="config.filterOptions && config.filterOptions.length > 0" class="spacer-bottom-none" style="background-color: lightgrey; padding: 5px; border-radius: 4px;">\n' +
    '                <div ng-repeat="filterOption in config.filterOptions">\n' +
    '                    <div>\n' +
    '                        <label>{{filterOption.label}}</label>\n' +
    '                        <div class="btn-group" style="max-width: 100%" dropdown>\n' +
    '                            <button type="button" class="btn btn-primary dropdown-toggle chooser-dropdown" ng-class="{\'btn-info\' : (config.getSelectedFilterDisplay(filterOption) !== \'All\')}" dropdown-toggle>{{config.getSelectedFilterDisplay(filterOption)}} <span class="caret"></span></button>\n' +
    '                            <ul class="dropdown-menu" role="menu">\n' +
    '                                <li ng-click="config.removeFilter(filterOption); closeDropdown($event)"><a href="">All</a></li>\n' +
    '                                <li ng-class="{\'active\' : config.isFilterSelected(filterOption, value)}" ng-repeat="value in filterOption.values| orderBy:filterOption.sortProperty" ng-click="config.setFilter(filterOption, value); closeDropdown($event)"><a href="">{{value[filterOption.displayProperty]}}</a></li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '        <div ng-if="!config.overheadControlsOnly">\n' +
    '            <div class="col-xs-4 item-chooser-sidebar" style="padding-right: 0px;">\n' +
    '                <div ng-show="config.filterOptions && config.filterOptions.length > 0" class="spacer-bottom-none" style="background-color: lightgrey; padding: 10px; border-radius: 4px;">\n' +
    '                    <div class="spacer-bottom-very-small" ng-repeat="filterOption in config.filterOptions">\n' +
    '                        <div>\n' +
    '                            <label>{{filterOption.label}}</label>\n' +
    '                            <div class="btn-group btn-block" dropdown>\n' +
    '                                <button type="button" class="btn btn-primary dropdown-toggle chooser-dropdown" ng-class="{\'btn-info\' : (config.getSelectedFilterDisplay(filterOption) !== \'All\')}" dropdown-toggle>{{config.getSelectedFilterDisplay(filterOption)}} <span class="caret"></span></button>\n' +
    '                                <ul class="dropdown-menu" role="menu">\n' +
    '                                    <li ng-click="config.removeFilter(filterOption); closeDropdown($event)"><a href="">All</a></li>\n' +
    '                                    <li ng-class="{\'active\' : config.isFilterSelected(filterOption, value)}" ng-repeat="value in filterOption.values| orderBy:filterOption.sortProperty" ng-click="config.setFilter(filterOption, value); closeDropdown($event)"><a href="">{{value[filterOption.displayProperty]}}</a></li>\n' +
    '                                </ul>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div ng-show="config.sortOptions.length > 0" style="background-color: lightgrey; padding: 10px; border-radius: 4px;">\n' +
    '                    <label>Sort By</label>\n' +
    '                    <div class="btn-group btn-block" dropdown>\n' +
    '                        <button type="button" class="btn btn-primary dropdown-toggle chooser-dropdown" dropdown-toggle ng-click="$event.stopPropagation();">\n' +
    '                            <span ng-style="config.getSortLabelStyle()">\n' +
    '                                {{config.getSortLabel().option}}\n' +
    '                            </span>\n' +
    '                            <span>\n' +
    '                                {{config.getSortLabel().direction}}\n' +
    '                            </span>\n' +
    '                            <span class="caret"></span>\n' +
    '                        </button>\n' +
    '                        <ul class="dropdown-menu" role="menu">\n' +
    '                            <li ng-repeat-start="option in config.sortOptions| orderBy:\'label\'" ng-click="config.setSort(option, false); closeDropdown($event)" ng-show="config.isShowSort(option, false)">\n' +
    '                                <a href="">\n' +
    '                                    <span ng-style="option.labelStyle">\n' +
    '                                        {{option.label}}\n' +
    '                                    </span>\n' +
    '                                    {{config.getSortKindLabel(option, (angular.isDefined(option.kind) ? false : undefined))}}\n' +
    '                                </a>\n' +
    '                            </li>\n' +
    '                            <li ng-repeat-end ng-click="config.setSort(option, true); closeDropdown($event)"  ng-show="config.isShowSort(option, true)">\n' +
    '                                <a href="">\n' +
    '                                    <span ng-style="option.labelStyle">\n' +
    '                                        {{option.label}}\n' +
    '                                    </span>\n' +
    '                                    {{config.getSortKindLabel(option, true)}}\n' +
    '                                </a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="row" ng-show="angular.isUndefined(config.sortOptions[0].kind)">\n' +
    '                        <div class="col col-xs-12 col-sm-6 text-center">\n' +
    '                            <label class="vertical-sort" title="Ascending">\n' +
    '                                <input type="radio" ng-model="config.state.sortReverse" ng-value="false" ng-change="config.clearResume()">\n' +
    '                                Asc\n' +
    '                            </label>\n' +
    '                        </div>\n' +
    '                        <div class="col col-xs-12 col-sm-6 text-center">\n' +
    '                            <label class="vertical-sort" title="Descending">\n' +
    '                                <input type="radio" ng-model="config.state.sortReverse" ng-value="true" ng-change="config.clearResume()">\n' +
    '                                Desc\n' +
    '                            </label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="text-right">\n' +
    '                        <hr>\n' +
    '                        <label>\n' +
    '                            <span ng-show="config.items.$resolved">{{config.items.length}}{{config.allItemsRetrieved ? \'\' : \'+\'}}</span>\n' +
    '                            <span ng-show="config.items.length !== 1">{{config.itemProperties.name.plural}}</span>\n' +
    '                            <span ng-show="config.items.length === 1">{{config.itemProperties.name.singular}}</span>\n' +
    '                        </label>\n' +
    '                        <button type="button" class="btn btn-sm btn-primary" ng-click="config.nextPage(true)">Get All</button>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div cg-busy="config.customLoading" ng-class="config.overheadControlsOnly ? \'col-xs-12\' : \'col-xs-8\'" fullscreen-height fullscreen-height-edit-flag="config.editFlag && config.dragEnabled" fullscreen-height-edit-override="config.editOverride" fullscreen-height-dependable="true">\n' +
    '            <div is-disabled="!config.dragEnabled" class="panel-border text-center" style="background-color: lightgrey; max-height: inherit; overflow-y: hidden;" as-sortable="config.sortListeners" ng-model="config.items">\n' +
    '                <ul class="ihh-item-source list-group" style="{{config.isModal ? \'height: \' + config.modalHeight + \'; overflow-y: auto; padding-left: 20px;\' : \'\'}} margin: 0px; max-height: inherit; overflow-y: auto;" in-view-container>\n' +
    '                    <a ng-href="{{item.link|| config.getLink(item)}}" \n' +
    '                       ng-repeat="item in config.items| chooserFilter: config as results"\n' +
    '                       ng-click="item.isDisabled || config.select(item)" \n' +
    '                       ng-class="{\'active\' : (config.isInSelected(item)), \'col-xs-12 col-lg-6\' : config.overheadControlsOnly && !config.singleColumn, \'grid-item\' : (config.layout === \'grid\'), \'is-disabled\' : item.isDisabled}"\n' +
    '                       class="list-group-item btn btn-default ihh-item"\n' +
    '                       style="cursor: pointer; padding-left: 5px; padding-right: 5px;"\n' +
    '                       ng-style="config.customStyle"\n' +
    '                       ng-if="!item.hidden"\n' +
    '                       as-sortable-item\n' +
    '                       as-sortable-item-handle>\n' +
    '                        <div ng-show="!config.transclude">\n' +
    '                            <div ng-include="config.templateUrl"></div>                        \n' +
    '                        </div>\n' +
    '                        <div ng-show="config.transclude">\n' +
    '                            <button type="button" ng-show="config.quickViewEnabled" class="btn btn-primary btn-xs display-quick-view-button" ng-click="config.displayQuickView($event, item);" no-drag><span class="glyphicon glyphicon-zoom-in" no-drag></span></button>\n' +
    '                            <ihh-item config="config" item="item">\n' +
    '                                <div id="transcluded" ng-transclude></div>\n' +
    '                            </ihh-item>\n' +
    '                            <button type="button" ng-show="config.quickAddEnabled" class="btn btn-primary btn-xs display-quick-add-button" ng-click="config.quickAdd($event, item);" no-drag><span class="glyphicon glyphicon-plus" no-drag></span></button>\n' +
    '                        </div>\n' +
    '                        <div class="clearfix"></div>\n' +
    '                    </a>\n' +
    '                    <span ng-show="config.countShown(results) === 0 && config.items.$resolved">[No {{config.itemProperties.name.plural}} to display.]</span>\n' +
    '                    <button type="button" class="btn btn-info" ng-class="{\'grid-item\' : (config.layout === \'grid\')}" ng-style="config.layout === \'grid\' ? \'\' : {\'width\': \'100%\'}" \n' +
    '                            in-view="$inview && config.nextPage()"\n' +
    '                            ng-if="!config.localManipOnly && ((angular.isUndefined(config.items.$resolved) || config.items.$resolved) && !config.allItemsRetrieved)"\n' +
    '                            ng-click="config.nextPage()"\n' +
    '                            ng-disabled="config.allItemsRetrieved">More</button>\n' +
    '                </ul>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('item-chooser/item.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('item-chooser/item.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="media">\n' +
    '    <div ng-show="config.itemProperties.hasThumbnail" class="media-left media-middle">\n' +
    '        <img ng-src="{{item.thumbnailUrl}}" class="media-object img-rounded" draggable="false" width="48">\n' +
    '    </div>\n' +
    '    <div class="media-body text-left" ng-style="config.itemProperties.hasThumbnail ? {\'width\': \'100%\'} : {}">\n' +
    '        <div ng-show="!config.itemProperty">\n' +
    '            <div ng-show="!config.singleLine">\n' +
    '                <div class="media-heading">\n' +
    '                    <strong class="ihh-item-text" title="{{item[config.state.sort]}}">{{item[config.state.sort]}}</strong>\n' +
    '                </div>\n' +
    '                <div ng-repeat="field in config.sortOptions">\n' +
    '                    <div ng-show="config.state.sort !== field.property" class="col-xs-offset-1">\n' +
    '                        <span class="ihh-item-text" title="{{item[field.property]}}">{{item[field.property] ? item[field.property] : \'&nbsp;\'}}</span>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="pull-right" ng-if="config.state.whose === \'clinic\'">\n' +
    '                    {{item.author.lastName}}, {{item.author.firstName}}\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div ng-show="config.singleLine">\n' +
    '                <div class="media-heading">\n' +
    '                    <strong>\n' +
    '                        {{item[config.state.sort]}}\n' +
    '                        <span class="ihh-item-text" ng-repeat="field in config.sortOptions" ng-show="config.state.sort !== field.property" title="{{item[field.property]}}">\n' +
    '                            {{item[field.property] ? item[field.property] : \'&nbsp;\'}}\n' +
    '                        </span>\n' +
    '                    </strong>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div ng-show="config.itemProperty">\n' +
    '            <div class="media-heading">\n' +
    '                <strong class="ihh-item-text">{{item[config.itemProperty]}}</strong>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('item-chooser/modal-item-chooser.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('item-chooser/modal-item-chooser.tpl.html',
    '<div class="modal-header ihh-item-chooser">\n' +
    '    <h3 class="modal-title">Choose {{config.itemProperties.name.singular}}</h3>\n' +
    '</div>\n' +
    '<div class="modal-body ihh-item-chooser">\n' +
    '    <ihh-item-chooser config="config"></ihh-item-chooser>\n' +
    '</div>\n' +
    '<div class="modal-footer ihh-item-chooser">\n' +
    '    <button type="button" class="btn btn-default" ng-click="cancel()">\n' +
    '        <span class="glyphicon glyphicon-remove-sign" style="color: #555;"></span>\n' +
    '        Cancel\n' +
    '    </button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('item-chooser/thumbnail-row.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('item-chooser/thumbnail-row.tpl.html',
    '<div class="col col-xs-12 thumbnail-content-area">\n' +
    '    <div ng-repeat="exerciseTemplate in exerciseTemplates track by $index" class="pull-left">\n' +
    '        <span ng-hide="thumbnailLimit <= $index">\n' +
    '            <img class="exercise-thumbnail-image" ng-src="{{exerciseTemplate.exercise.thumbnailUrl}}" draggable="false" width="48" style="margin-right: 4px;"/>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '    <div class="pull-left" style="width:48px;">\n' +
    '        <span ng-show="thumbnailLimit <= exerciseTemplates.length && exerciseTemplates.length - thumbnailLimit > 0">+ {{exerciseTemplates.length - thumbnailLimit}}<br/>more</span>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('layouts/thumbnail-box.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('layouts/thumbnail-box.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-15 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div ng-if="!thumbnailRight" class="row">\n' +
    '    <div class="col col-xs-3">\n' +
    '        <img ng-src="{{imageHref}}" class="img-responsive img-rounded" width="{{width ? width : \'50\'}}"/>\n' +
    '    </div>\n' +
    '    <div class="col col-xs-9">\n' +
    '        <div ng-transclude></div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="thumbnailRight" class="row">\n' +
    '    <div class="col col-xs-9">\n' +
    '        <div ng-transclude></div>\n' +
    '    </div>\n' +
    '    <div class="col col-xs-3">\n' +
    '        <img ng-src="{{imageHref}}" class="img-responsive img-rounded" style="float: right;" width="{{width ? width : \'50\'}}"/>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('navbar/navbar.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('navbar/navbar.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="navbar navbar-default {{navbarStyles}}">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="navbar-header">\n' +
    '            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#{{collapseId}}" ng-show="hasCollapsible()">\n' +
    '                <span class="sr-only">Toggle navigation</span>\n' +
    '                <!-- the below generates a wider version of glyphicon-menu-hamburger -->\n' +
    '                <span class="icon-bar"></span>\n' +
    '                <span class="icon-bar"></span>\n' +
    '                <span class="icon-bar"></span>\n' +
    '            </button>\n' +
    '            <div ng-if="!brandImage" class="navbar-brand">\n' +
    '                <button ng-if="!noButton" type="button" ng-click="onBrandClick()" style="margin-top: -3px;">\n' +
    '                    <span class="glyphicon {{brandGlyphicon}}" style="color: #555;"></span>\n' +
    '                </button>\n' +
    '                <span class="truncate-overflow truncate-brand-text">{{brand}}</span>\n' +
    '            </div>\n' +
    '            <div ng-if="brandImage" class="navbar-brand">\n' +
    '                <a href="{{brandUrl}}">\n' +
    '                    <img ng-src="{{brandImage}}" class="img-responsive pull-left brand-image">\n' +
    '                </a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        \n' +
    '        <div class="collapse navbar-collapse" id="{{collapseId}}" ng-show="hasCollapsible()">\n' +
    '            <div ng-show="hasHelp()" class="navbar-brand navbar-right">\n' +
    '                <a href="https://www.inhandhealth.com/support/ptih-help.php" target="_blank">\n' +
    '                    <span class="glyphicon glyphicon-question-sign"></span>\n' +
    '                </a>\n' +
    '            </div>\n' +
    '            <div ng-transclude></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('payment-method-entry/payment-method-entry.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('payment-method-entry/payment-method-entry.tpl.html',
    '<!--\n' +
    'Copyright (c) 2016 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div cg-busy="{promise: PaymentMethodEntryVm.isLoadingPaymentToken, minDuration: 300, delay: 0}" class="pt-section">\n' +
    '    <div>\n' +
    '        <form novalidate id="checkout">\n' +
    '            <div class="pt-section pt-subsection">\n' +
    '                <div>\n' +
    '                    <a href="https://www.braintreegateway.com/merchants/ymq3n663bz7xcjmf/verified" target="_blank">\n' +
    '                        <img src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png" class="braintree-img" alt="Payments by Braintree"/>\n' +
    '                    </a>\n' +
    '                </div>\n' +
    '                <div id="payment-form"></div>\n' +
    '            </div>\n' +
    '            <button type="submit" id="checkoutSubmit" value="Set New Payment Method" ng-show="false"></button>\n' +
    '        </form> \n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('prescription-content/prescription-content-edit.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('prescription-content/prescription-content-edit.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-16 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="pe-edit">\n' +
    '    <div class="panel-body prescription-exercises-list" \n' +
    '         ng-class="{\'dropzone\': isEmptyDropzone()}" \n' +
    '         ng-style="isEmptyDropzone() ? {\'margin\': \'15px\'} : {}" \n' +
    '         as-sortable="sortListeners" \n' +
    '         ng-model="exerciseTemplates">\n' +
    '        <div as-sortable-item \n' +
    '             ng-repeat="exerciseTemplate in exerciseTemplates">\n' +
    '            <div as-sortable-item-handle class="col col-xs-12 exercise-container">\n' +
    '                <div class="exercise-border">\n' +
    '                    <img class="thumbnail-left-edit" \n' +
    '                         ng-src="{{getExerciseThumbnailUrl(exerciseTemplate)}}">\n' +
    '                    <div class="row thumbnail-to-left">\n' +
    '                        <a class="col col-xs-12 pe-split exercise-link" \n' +
    '                           ng-class="{\'disabled\' : getExerciseLinkUrl(exerciseTemplate, true) === null}" \n' +
    '                           ng-href="{{getExerciseLinkUrl(exerciseTemplate, isEdit)}}">\n' +
    '                            <div class="exercise-name">\n' +
    '                                {{exerciseTemplate.exercise.name ? exerciseTemplate.exercise.name : "No Name"}}\n' +
    '                            </div>\n' +
    '                            <div class="exercise-title">\n' +
    '                                {{exerciseTemplate.exercise.title ? exerciseTemplate.exercise.title : "No Title"}}\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '\n' +
    '                        <div class="col col-xs-12 pe-split">\n' +
    '                            <div class="row-fluid">\n' +
    '                                <div ng-if="!exerciseTemplate.exercise.reportOnly">\n' +
    '                                    <div class="col pe-col form-group form-group-select">\n' +
    '                                        <label class="control-label">Units</label>\n' +
    '                                        <div class="form-control form-control-btn btn-group dropdown-container" dropdown>\n' +
    '                                            <button type="button" class="btn btn-primary dropdown-toggle" dropdown-toggle>{{getValueString(getQuantityType(exerciseTemplate))}} <span class="caret"></span></button>\n' +
    '                                            <ul class="dropdown-menu" role="menu">\n' +
    '                                                <li ng-repeat="quantityType in quantityTypes" ng-click="selectQuantityType(quantityType, exerciseTemplate, prescriptionForm, $event);"><a href="">{{getValueString(quantityType)}}</a></li>\n' +
    '                                            </ul>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div class="col pe-col required form-group">\n' +
    '                                        <label class="control-label">Sets</label>\n' +
    '                                        <input type="number" \n' +
    '                                               min="0" \n' +
    '                                               ng-required="true" \n' +
    '                                               class="form-control" \n' +
    '                                               ng-model="exerciseTemplate.sets" \n' +
    '                                               ihh-valid-if="true"\n' +
    '                                               ui-options="{clearOnBlur: false}">\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div ng-if="displayQuantityType(\'Repetitions\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                        <div class="col pe-col required form-group">\n' +
    '                                            <label class="control-label">Reps</label>\n' +
    '                                            <input type="number" \n' +
    '                                                   min="0" \n' +
    '                                                   ng-required="true" \n' +
    '                                                   class="form-control" \n' +
    '                                                   ng-model="exerciseTemplate.repetitions" \n' +
    '                                                   ihh-valid-if="true"\n' +
    '                                                   ui-options="{clearOnBlur: false}">\n' +
    '                                        </div>\n' +
    '                                        <div class="col pe-col required form-group">\n' +
    '                                            <label class="control-label">Secs/Rep</label>\n' +
    '                                            <input type="number" \n' +
    '                                                   min="0" \n' +
    '                                                   ng-required="true" \n' +
    '                                                   class="form-control" \n' +
    '                                                   ng-model="exerciseTemplate.secondsPerRep" \n' +
    '                                                   ihh-valid-if="true"\n' +
    '                                                   ui-options="{clearOnBlur: false}">\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div ng-if="displayQuantityType(\'Duration\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                        <div class="col pe-col required form-group">\n' +
    '                                            <label class="control-label">Seconds</label>\n' +
    '                                            <input type="number" \n' +
    '                                                   min="0" \n' +
    '                                                   ng-required="true" \n' +
    '                                                   class="form-control" \n' +
    '                                                   ng-model="exerciseTemplate.duration" \n' +
    '                                                   ihh-valid-if="true"\n' +
    '                                                   ui-options="{clearOnBlur: false}">\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '\n' +
    '                                    <div ng-if="isMetronome(exerciseTemplate)">\n' +
    '                                        <div class="col pe-col form-group">\n' +
    '                                            <label class="control-label">Metronome (bpm)</label>\n' +
    '                                            <div class="input-group">\n' +
    '                                                <input type="number" \n' +
    '                                                       min="0" \n' +
    '                                                       ng-required="false" \n' +
    '                                                       class="form-control" \n' +
    '                                                       ng-model="exerciseTemplate.metronome" \n' +
    '                                                       ihh-valid-if="true"\n' +
    '                                                       ui-options="{clearOnBlur: false}">\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <ihh-view-edit-select \n' +
    '                                    ng-if="exerciseTemplate.exercise.resistanceItem"\n' +
    '                                    class="col pe-col" \n' +
    '                                    control-id="{{::getControlId(idPrefix, \'ResistanceItemValue\', parentIndex, $id)}}"\n' +
    '                                    label="{{exerciseTemplate.resistanceItem.type|| exerciseTemplate.exercise.resistanceItem.type}}" \n' +
    '                                    edit-flag="true" \n' +
    '                                    containing-model-default="exerciseTemplate.exercise"\n' +
    '                                    containing-model="exerciseTemplate"\n' +
    '                                    containing-form="prescriptionForm"\n' +
    '                                    get="getResistanceItemValue" \n' +
    '                                    set="setResistanceItemValue" \n' +
    '                                    values="exerciseTemplate.resistanceItem.resistances"\n' +
    '                                    values-defaults="exerciseTemplate.exercise.resistanceItem.resistances">\n' +
    '                                </ihh-view-edit-select>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="btn-group-vertical btn-group-up-right-stack-down">\n' +
    '                            <button type="button" class="btn btn-xs btn-danger" ng-click="deleteExerciseTemplate(prescriptionForm, exerciseTemplate)">\n' +
    '                                <span class="glyphicon glyphicon-trash"></span>\n' +
    '                            </button>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="badge badge-info badge-right-center" ng-if="!exerciseTemplate._expanded && (exerciseTemplate.ttsCuesAndTips || exerciseTemplate.ttsInstructions)">\n' +
    '                            <small>TTS</small>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="btn-group-vertical btn-group-down-right-stack-down">\n' +
    '                            <button type="button" class="btn btn-xs btn-primary" ng-if="exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                <span class="text-danger glyphicon glyphicon-chevron-down"></span>\n' +
    '                            </button>\n' +
    '                            <button type="button" class="btn btn-xs btn-primary" ng-if="!exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                <span class="glyphicon glyphicon-chevron-left"></span>\n' +
    '                            </button>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div ng-if="exerciseTemplate._expanded">\n' +
    '                        <div class="row">\n' +
    '                            <div class="col col-xs-12 textarea-view-mode">\n' +
    '                                <div class="pull-right">\n' +
    '                                    <input type="checkbox" ng-model="exerciseTemplate.ttsInstructions">\n' +
    '                                    <label>Use Text-To-Speech (TTS)</label>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="control-label">Instructions</label>\n' +
    '                                    <textarea rows="4"\n' +
    '                                              class="form-control"\n' +
    '                                              style="resize: vertical;"\n' +
    '                                              focus="false"\n' +
    '                                              ng-required="false"\n' +
    '                                              ng-model="exerciseTemplate.instructions"\n' +
    '                                              ng-change="setTtsInstructions(exerciseTemplate)">\n' +
    '                                    </textarea>\n' +
    '                                </div>                                \n' +
    '                            </div>\n' +
    '                            <div class="col col-xs-12 textarea-view-mode">\n' +
    '                                <div class="pull-right">\n' +
    '                                    <input type="checkbox" ng-model="exerciseTemplate.ttsCuesAndTips">\n' +
    '                                    <label>\n' +
    '                                        Use Text-To-Speech (TTS)\n' +
    '                                    </label>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="control-label">Cues & Tips</label>\n' +
    '                                    <textarea rows="4"\n' +
    '                                              class="form-control"\n' +
    '                                              style="resize: vertical;"\n' +
    '                                              focus="false"\n' +
    '                                              ng-required="false"\n' +
    '                                              ng-model="exerciseTemplate.cuesAndTips"\n' +
    '                                              ng-change="setTtsCuesAndTips(exerciseTemplate)">\n' +
    '                                    </textarea>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('prescription-content/prescription-content-view.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('prescription-content/prescription-content-view.tpl.html',
    '<!--\n' +
    'Copyright (c) 2016 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="pe-no-edit">\n' +
    '    <div class="panel-body prescription-exercises-list" ng-model="exerciseTemplates">\n' +
    '        <div ng-repeat="exerciseTemplate in ::exerciseTemplates">\n' +
    '            <div class="col col-xs-12 exercise-container">\n' +
    '                <div class="exercise-border">\n' +
    '                    <img class="thumbnail-left-edit" \n' +
    '                         ng-src="{{getExerciseThumbnailUrl(exerciseTemplate)}}">\n' +
    '                    <div class="row thumbnail-to-left">\n' +
    '                        <a class="col col-xs-12 pe-split exercise-link" \n' +
    '                           ng-class="{\'disabled\' : getExerciseLinkUrl(exerciseTemplate) === null}" \n' +
    '                           ng-href="{{getExerciseLinkUrl(exerciseTemplate)}}">\n' +
    '                            <div class="exercise-name">\n' +
    '                                {{exerciseTemplate.exercise.name ? exerciseTemplate.exercise.name : \'No Name\'}}\n' +
    '                            </div>\n' +
    '                            <div class="exercise-title">\n' +
    '                                {{exerciseTemplate.exercise.title ? exerciseTemplate.exercise.title : \'No Title\'}}\n' +
    '                            </div>\n' +
    '                        </a>\n' +
    '                        <div class="col col-xs-12 pe-split exercise-details">\n' +
    '                            <div class="row-fluid">\n' +
    '                                <div ng-if="!exerciseTemplate.exercise.reportOnly">\n' +
    '                                    <div class="col pe-col">\n' +
    '                                        <div class="form-group">\n' +
    '                                            <label>Sets</label>\n' +
    '                                            <div>\n' +
    '                                                {{exerciseTemplate.sets|| exerciseTemplate.exercise.sets}}\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div ng-if="displayQuantityType(\'Repetitions\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                        <div class="col pe-col">\n' +
    '                                            <div class="form-group">\n' +
    '                                                <label>Reps</label>\n' +
    '                                                <div>\n' +
    '                                                    {{exerciseTemplate.repetitions|| exerciseTemplate.exercise.repetitions}}\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                        <div class="col pe-col">\n' +
    '                                            <div class="form-group">\n' +
    '                                                <label>Secs/Rep</label>\n' +
    '                                                <div>\n' +
    '                                                    {{exerciseTemplate.secondsPerRep|| exerciseTemplate.exercise.secondsPerRep}}\n' +
    '                                                </div>\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div class="col pe-col" ng-if="displayQuantityType(\'Duration\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)">\n' +
    '                                        <div class="form-group">\n' +
    '                                            <label>Seconds</label>\n' +
    '                                            <div>\n' +
    '                                                {{exerciseTemplate.duration|| exerciseTemplate.exercise.duration}}\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                    <div class="col pe-col" ng-if="isMetronome(exerciseTemplate)">\n' +
    '                                        <div class="form-group">\n' +
    '                                            <label>Metronome (bpm)</label>\n' +
    '                                            <div>\n' +
    '                                                {{getMetronome(exerciseTemplate)}}\n' +
    '                                            </div>\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div class="col pe-col" ng-if="exerciseTemplate.exercise.resistanceItem">\n' +
    '                                    <div class="form-group">\n' +
    '                                        <label>{{exerciseTemplate.resistanceItem.type|| exerciseTemplate.exercise.resistanceItem.type}}</label>\n' +
    '                                        <div>\n' +
    '                                            {{getResistanceItemValue(exerciseTemplate)}}\n' +
    '                                        </div>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="badge badge-info badge-right-center badge-right-top" ng-if="!exerciseTemplate._expanded && (exerciseTemplate.ttsCuesAndTips || exerciseTemplate.ttsInstructions)">\n' +
    '                            <small>TTS</small>\n' +
    '                        </div>\n' +
    '\n' +
    '                        <div class="btn-group-vertical btn-group-down-right-stack-down">\n' +
    '                            <button type="button" class="btn btn-xs btn-primary" ng-if="exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                <span class="text-danger glyphicon glyphicon-chevron-down"></span>\n' +
    '                            </button>\n' +
    '                            <button type="button" class="btn btn-xs btn-primary" ng-if="!exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                                <span class="glyphicon glyphicon-chevron-left"></span>\n' +
    '                            </button>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div ng-if="exerciseTemplate._expanded">\n' +
    '                        <div class="row">\n' +
    '                            <div class="col col-xs-12" style="margin-top: 15px;">\n' +
    '                                <div class="pull-right">\n' +
    '                                    <span ng-if="exerciseTemplate.ttsInstructions">Text-To-Speech (TTS) Enabled</span>\n' +
    '                                    <span ng-if="!exerciseTemplate.ttsInstructions">Text-To-Speech (TTS) Disabled</span>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="control-label">Instructions</label>\n' +
    '                                    <div class="pre-whitespace truncate-offset">\n' +
    '                                        {{exerciseTemplate.instructions|| exerciseTemplate.exercise.instructions}}\n' +
    '                                    </div>\n' +
    '                                </div>                                \n' +
    '                            </div>\n' +
    '                            <div class="col col-xs-12" style="margin-top: 15px;">\n' +
    '                                <div class="pull-right">\n' +
    '                                    <span ng-if="exerciseTemplate.ttsCuesAndTips">Text-To-Speech (TTS) Enabled</span>\n' +
    '                                    <span ng-if="!exerciseTemplate.ttsCuesAndTips">Text-To-Speech (TTS) Disabled</span>\n' +
    '                                </div>\n' +
    '\n' +
    '                                <div class="form-group">\n' +
    '                                    <label class="control-label">Cues & Tips</label>\n' +
    '                                    <div class="pre-whitespace truncate-offset">\n' +
    '                                        {{exerciseTemplate.cuesAndTips|| exerciseTemplate.exercise.cuesAndTips}}\n' +
    '                                    </div>\n' +
    '                                </div>                            \n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('rx-exercise-template/rx-exercise-template.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('rx-exercise-template/rx-exercise-template.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-16 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="panel-body prescriptionExercisesList" ng-class="{\'dropzone\': isEmptyDropzone()}" ng-style="isEmptyDropzone() ? {\'margin\': \'15px\'} : {}" as-sortable="sortListeners" is-disabled="!isEdit" ng-model="editExerciseTemplates">\n' +
    '    <div as-sortable-item ng-repeat="exerciseTemplate in {false: viewExerciseTemplates, true: editExerciseTemplates}[isEdit]">\n' +
    '        <div as-sortable-item-handle class="col col-xs-12" ng-style="!isEdit ? {\'cursor\': \'auto\'} : {}" style="background-color: white; padding-left: 0px; padding-right: 0px;">\n' +
    '            <div class="exercise-border">\n' +
    '                <img class="thumbnail-left-edit" width="50" ng-src="{{getExerciseThumbnailUrl(exerciseTemplate.exercise)}}">\n' +
    '                <div class="row thumbnail-to-left">\n' +
    '                    <a style="padding-bottom: 8px" class="col col-xs-12 pe-split" ng-class="{\'disabled\' : getExerciseLinkUrl(exerciseTemplate, isEdit) === null}" ng-href="{{getExerciseLinkUrl(exerciseTemplate, isEdit)}}">\n' +
    '                        <div style="font-weight: bold; padding-left: 10px;">{{exerciseTemplate.exercise.name ? exerciseTemplate.exercise.name : \'No Name\'}}</div>\n' +
    '                        <div style="padding-left: 10px;">{{exerciseTemplate.exercise.title ? exerciseTemplate.exercise.title : \'No Title\'}}</div>\n' +
    '                    </a>\n' +
    '\n' +
    '                    <div class="col col-xs-12 pe-split" style="padding-left: 15px" ng-style="!isEdit ? {\'text-align\': \'center\'} : {}">\n' +
    '                        <div class="row-fluid">\n' +
    '                            <div ng-if="!exerciseTemplate.exercise.reportOnly">\n' +
    '                                <ihh-view-edit-text class="col pe-col"\n' +
    '                                                    control-id="{{::getControlId(idPrefix, \'Sets\', parentIndex, $index)}}"\n' +
    '                                                    label="Sets" \n' +
    '                                                    text-type="number" number-min="0" \n' +
    '                                                    is-required="true" \n' +
    '                                                    edit-flag="isEdit" \n' +
    '                                                    model="exerciseTemplate.sets" \n' +
    '                                                    model-edit="exerciseTemplate.sets"\n' +
    '                                                    model-default="exerciseTemplate.exercise.sets">\n' +
    '                                </ihh-view-edit-text>\n' +
    '                                <ihh-view-edit-text class="col pe-col" ng-show="displayQuantityType(\'Repetitions\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)"\n' +
    '                                                    control-id="{{::getControlId(idPrefix, \'Repetitions\', parentIndex, $index)}}"\n' +
    '                                                    label="Reps" \n' +
    '                                                    text-type="number" number-min="0" \n' +
    '                                                    is-required="exerciseTemplate.quantityType === \'Repetitions\'" \n' +
    '                                                    edit-flag="isEdit" \n' +
    '                                                    model="exerciseTemplate.repetitions" \n' +
    '                                                    model-edit="exerciseTemplate.repetitions"\n' +
    '                                                    model-default="exerciseTemplate.exercise.repetitions">\n' +
    '                                </ihh-view-edit-text>\n' +
    '                                <ihh-view-edit-text class="col pe-col" ng-show="displayQuantityType(\'Repetitions\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)"\n' +
    '                                                    control-id="{{::getControlId(idPrefix, \'SecondsPerRep\', parentIndex, $index)}}"\n' +
    '                                                    label="Secs/Rep" \n' +
    '                                                    text-type="number" number-min="0" \n' +
    '                                                    is-required="exerciseTemplate.quantityType === \'Repetitions\'" \n' +
    '                                                    edit-flag="isEdit" \n' +
    '                                                    model="exerciseTemplate.secondsPerRep" \n' +
    '                                                    model-edit="exerciseTemplate.secondsPerRep"\n' +
    '                                                    model-default="exerciseTemplate.exercise.secondsPerRep">\n' +
    '                                </ihh-view-edit-text>\n' +
    '                                <ihh-view-edit-text class="col pe-col" ng-show="displayQuantityType(\'Duration\', exerciseTemplate.quantityType, exerciseTemplate.exercise.quantityType)"\n' +
    '                                                    control-id="{{::getControlId(idPrefix, \'Duration\', parentIndex, $index)}}"\n' +
    '                                                    label="Seconds" \n' +
    '                                                    text-type="number" number-min="0" \n' +
    '                                                    is-required="exerciseTemplate.quantityType === \'Duration\'" \n' +
    '                                                    edit-flag="isEdit" \n' +
    '                                                    model="exerciseTemplate.duration" \n' +
    '                                                    model-edit="exerciseTemplate.duration"\n' +
    '                                                    model-default="exerciseTemplate.exercise.duration">\n' +
    '                                </ihh-view-edit-text>\n' +
    '                            </div>\n' +
    '                            <ihh-view-edit-select class="col pe-col" ng-if="exerciseTemplate.exercise.resistanceItem"\n' +
    '                                                  control-id="{{::getControlId(idPrefix, \'ResistanceItemValue\', parentIndex, $index)}}"\n' +
    '                                                  label="{{exerciseTemplate.resistanceItem.type|| exerciseTemplate.exercise.resistanceItem.type}}" \n' +
    '                                                  edit-flag="isEdit" \n' +
    '                                                  containing-model-default="exerciseTemplate.exercise"\n' +
    '                                                  containing-model="exerciseTemplate"\n' +
    '                                                  containing-form="containingForm"\n' +
    '                                                  get="getResistanceItemValue" \n' +
    '                                                  set="setResistanceItemValue" \n' +
    '                                                  values="exerciseTemplate.resistanceItem.resistances"\n' +
    '                                                  values-defaults="exerciseTemplate.exercise.resistanceItem.resistances">\n' +
    '                            </ihh-view-edit-select>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="btn-group-vertical btn-group-up-right-stack-down">\n' +
    '                        <button type="button" class="btn btn-xs btn-danger" ng-show="isEdit" ng-click="deleteExerciseTemplate(containingForm, prescriptionTemplate, $index)">\n' +
    '                            <span class="glyphicon glyphicon-trash"></span>\n' +
    '                        </button>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="badge badge-info badge-right-center" ng-class="{\'badge-right-center\': isEdit, \'badge-right-top\': !isEdit}" ng-if="!exerciseTemplate._expanded && (exerciseTemplate.ttsCuesAndTips || exerciseTemplate.ttsInstructions)">\n' +
    '                        <small>TTS</small>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="btn-group-vertical btn-group-down-right-stack-down">\n' +
    '                        <button type="button" class="btn btn-xs btn-primary" ng-if="exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                            <span class="text-danger glyphicon glyphicon-chevron-down"></span>\n' +
    '                        </button>\n' +
    '                        <button type="button" class="btn btn-xs btn-primary" ng-if="!exerciseTemplate._expanded" ng-click="exerciseTemplate._expanded = !exerciseTemplate._expanded">\n' +
    '                            <span class="glyphicon glyphicon-chevron-left"></span>\n' +
    '                        </button>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div ng-show="exerciseTemplate._expanded">\n' +
    '                    <ihh-view-edit-select class="" ng-show="isEdit"\n' +
    '                                          control-id="{{::getControlId(idPrefix, \'QuantityType\', parentIndex, $index)}}"\n' +
    '                                          label="" \n' +
    '                                          edit-flag="isEdit"\n' +
    '                                          containing-model-default="exerciseTemplate.exercise"\n' +
    '                                          containing-model="exerciseTemplate"\n' +
    '                                          containing-form="containingForm"\n' +
    '                                          get="getQuantityType" \n' +
    '                                          set="setQuantityType" \n' +
    '                                          values="quantityTypes">\n' +
    '                    </ihh-view-edit-select>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col col-xs-12" style="margin-top: 15px;">\n' +
    '                            <div class="pull-right" ng-show="isEdit">\n' +
    '                                <input type="checkbox" id="{{::getControlId(idPrefix, \'tts1\', parentIndex, $index)}}" ng-model="exerciseTemplate.ttsInstructions">\n' +
    '                                <label for="{{::getControlId(idPrefix,\'tts1\',parentIndex,$index)}}">\n' +
    '                                    Use Text-To-Speech (TTS)\n' +
    '                                </label>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="pull-right" ng-show="!isEdit">\n' +
    '                                <span ng-if="exerciseTemplate.ttsInstructions">Text-To-Speech (TTS) Enabled</span>\n' +
    '                                <span ng-if="!exerciseTemplate.ttsInstructions">Text-To-Speech (TTS) Disabled</span>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <ihh-view-edit-textarea  \n' +
    '                                control-id="{{::getControlId(idPrefix, \'Instructions\', parentIndex, $index)}}" \n' +
    '                                label="Instructions" \n' +
    '                                rows="4"\n' +
    '                                is-required="false" \n' +
    '                                edit-flag="isEdit" \n' +
    '                                model="exerciseTemplate.instructions" \n' +
    '                                model-edit="exerciseTemplate.instructions"\n' +
    '                                model-default="exerciseTemplate.exercise.instructions"\n' +
    '                                on-change="setTtsInstructions(exerciseTemplate)">\n' +
    '                            </ihh-view-edit-textarea>\n' +
    '                        </div>\n' +
    '                        <div class="col col-xs-12" style="margin-top: 15px;">\n' +
    '                            <div class="pull-right" ng-show="isEdit">\n' +
    '                                <input type="checkbox" id="{{::getControlId(idPrefix, \'tts2\', parentIndex, $index)}}" ng-model="exerciseTemplate.ttsCuesAndTips">\n' +
    '                                <label for="{{::getControlId(idPrefix,\'tts2\',parentIndex,$index)}}">\n' +
    '                                    Use Text-To-Speech (TTS)\n' +
    '                                </label>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <div class="pull-right" ng-show="!isEdit">\n' +
    '                                <span ng-if="exerciseTemplate.ttsCuesAndTips">Text-To-Speech (TTS) Enabled</span>\n' +
    '                                <span ng-if="!exerciseTemplate.ttsCuesAndTips">Text-To-Speech (TTS) Disabled</span>\n' +
    '                            </div>\n' +
    '\n' +
    '                            <ihh-view-edit-textarea  \n' +
    '                                control-id="{{::getControlId(idPrefix, \'CuesAndTips\', parentIndex, $index)}}"\n' +
    '                                label="Cues & Tips" \n' +
    '                                rows="4"\n' +
    '                                is-required="false" \n' +
    '                                edit-flag="isEdit" \n' +
    '                                model="exerciseTemplate.cuesAndTips" \n' +
    '                                model-edit="exerciseTemplate.cuesAndTips"\n' +
    '                                model-default="exerciseTemplate.exercise.cuesAndTips"\n' +
    '                                on-change="setTtsCuesAndTips(exerciseTemplate)">\n' +
    '                            </ihh-view-edit-textarea>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('scrip-form/scrip-form.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('scrip-form/scrip-form.tpl.html',
    '<!--\n' +
    'Copyright (c) 2019 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="row center-block">\n' +
    '    <ihh-view-edit-text class="col col-xs-12" control-id="name" label="Name" is-required="true" edit-flag="vm.editFlag"\n' +
    '        model="vm.prescriptionObject.name" model-edit="vm.prescriptionObjectEdit.name" focus="vm.editFlag">\n' +
    '    </ihh-view-edit-text>\n' +
    '    <ihh-view-edit-text ng-show="vm.enableExpireAfterDays" class="col col-xs-12" control-id="enableExpireAfterDays"\n' +
    '        label="Expire After Days" text-type="number" edit-flag="vm.editFlag"\n' +
    '        model="vm.prescriptionObject.expireAfterDays" model-edit="vm.prescriptionObjectEdit.expireAfterDays">\n' +
    '    </ihh-view-edit-text>\n' +
    '    <ihh-view-edit-date ng-show="vm.enablePrescribeDate" show-time="true" class="col col-xs-12" label="Prescribe Date"\n' +
    '        is-edit="vm.editFlag" min-date="today" model="vm.prescriptionObject.prescribed"\n' +
    '        model-edit="vm.prescriptionObjectEdit.prescribed">\n' +
    '    </ihh-view-edit-date>\n' +
    '    <div class="col col-xs-12 form-group">\n' +
    '        <label class="control-label">Special Instructions</label>\n' +
    '        <div class="" ng-show="!vm.editFlag">\n' +
    '            {{vm.prescriptionObject.instructions|| \'N/A\'}}\n' +
    '        </div>\n' +
    '        <div class="" ng-show="vm.editFlag">\n' +
    '            <textarea class="form-control" ng-model="vm.prescriptionObjectEdit.instructions"></textarea>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="col col-xs-12 col-sm-6 form-group">\n' +
    '        <label ng-class="{\'control-label\': vm.editFlag}">\n' +
    '            Frequency\n' +
    '        </label>\n' +
    '        <div class="" ng-show="!vm.editFlag">\n' +
    '            {{vm.getFrequencyLabel(vm.prescriptionObject)}}\n' +
    '        </div>\n' +
    '        <div class="row" ng-show="vm.editFlag">\n' +
    '            <div class="col col-xs-12 form-inline">\n' +
    '                <div class="form-group" id="frequency">\n' +
    '                    <div class="btn-group" dropdown>\n' +
    '                        <button type="button" class="btn btn-primary dropdown-toggle" dropdown-toggle>\n' +
    '                            {{vm.prescriptionObjectEdit._frequencyOption.label}} <span class="caret"></span>\n' +
    '                        </button>\n' +
    '                        <ul class="dropdown-menu" role="menu">\n' +
    '                            <li ng-repeat="option in vm.frequencyOptions"\n' +
    '                                ng-click="vm.prescriptionObjectEdit._frequencyOption = option;closeDropdown($event);">\n' +
    '                                <a href="">{{option.label}}</a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="form-group" ng-show="vm.prescriptionObjectEdit._frequencyOption.custom">\n' +
    '                    <input class="form-control" type="number" ng-model="vm.prescriptionObjectEdit._frequencyNumber">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <ihh-view-edit-text class="col col-xs-12 col-sm-6" control-id="overdueDays" label="Delay overdue notification days"\n' +
    '        text-type="number" edit-flag="vm.editFlag" model="vm.prescriptionObject.overdueDays"\n' +
    '        model-edit="vm.prescriptionObjectEdit.overdueDays">\n' +
    '    </ihh-view-edit-text>\n' +
    '\n' +
    '    <div class="col col-xs-12 form-group">\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.trustClaimedAllDone"\n' +
    '                    ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.trustClaimedAllDone || vm.prescriptionObject.defaultTrustClaimedAllDone">\n' +
    '                {{vm.i18n.allowLogging}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.rememberWorkoutValues"\n' +
    '                    ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.rememberWorkoutValues || vm.prescriptionObject.defaultRememberWorkoutValues">\n' +
    '                {{vm.i18n.allowLastSurveyValues}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.workoutOnlyWhenDue"\n' +
    '                    ng-disabled="!vm.editFlag" ng-checked="vm.prescriptionObject.workoutOnlyWhenDue">\n' +
    '                {{vm.i18n.workoutOnlyWhenDue}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.doNotSurvey" ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.doNotSurvey">\n' +
    '                {{vm.i18n.doNotSurvey}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div ng-if="vm.enableGamifySequence">\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.gamifySequence" ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.gamifySequence">\n' +
    '                {{vm.i18n.gamifySequence}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.noCompliance" ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.noCompliance">\n' +
    '                {{vm.i18n.noCompliance}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.advanceWorkflow" ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.advanceWorkflow">\n' +
    '                {{vm.i18n.advanceWorkflow}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.notifyOnPerform" ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.notifyOnPerform">\n' +
    '                {{vm.i18n.notifyOnPerform}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '            <label class="checkbox-label">\n' +
    '                <input type="checkbox" ng-model="vm.prescriptionObjectEdit.performOnce" ng-disabled="!vm.editFlag"\n' +
    '                    ng-checked="vm.prescriptionObject.performOnce">\n' +
    '                {{vm.i18n.performOnce}}\n' +
    '            </label>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <ihh-view-edit-text ng-show="vm.showAutoExpire()" class="col col-xs-12 col-sm-6 col-lg-4"\n' +
    '        control-id="autoExpireMessage" label="{{vm.i18n.autoExpireMessage}}" edit-flag="vm.editFlag"\n' +
    '        model="vm.prescriptionObject.autoExpireMessage" model-edit="vm.prescriptionObjectEdit.autoExpireMessage">\n' +
    '    </ihh-view-edit-text>\n' +
    '    <ihh-view-edit-text ng-show="vm.showAutoExpire()" class="col col-xs-12 col-sm-6 col-lg-4" control-id="autoExpireUrl"\n' +
    '        label="{{vm.i18n.autoExpireUrl}}" edit-flag="vm.editFlag" model="vm.prescriptionObject.autoExpireUrl"\n' +
    '        model-edit="vm.prescriptionObjectEdit.autoExpireUrl">\n' +
    '    </ihh-view-edit-text>\n' +
    '</div>');
}]);

angular.module('scrip-template-chooser/protocol-template-item.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('scrip-template-chooser/protocol-template-item.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-2016 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '\n' +
    '<div class="media">\n' +
    '    <div class="media-body text-left row" style="width: 100%;">\n' +
    '        <div class="media-heading">\n' +
    '            <strong class="ihh-item-text" title="{{item.name|| item.title}}">{{item.name|| item.title}}\n' +
    '                <span ng-if="config.isRecent(item.created, 30)" class="text-success"> (RECENT)</span>\n' +
    '            </strong>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row" ihh-thumbnail-row exercise-templates="item.exerciseTemplates" config="config"></div>\n' +
    '    <div class="pull-right" ng-if="config.state.whose === \'clinic\'">\n' +
    '        {{item.author.lastName}}, {{item.author.firstName}}\n' +
    '    </div>\n' +
    '    <button type="button" ng-show="config.quickAddEnabled" class="btn btn-primary btn-xs display-quick-add-button" ng-click="config.quickAdd($event, item);" no-drag><span class="glyphicon glyphicon-plus" no-drag></span></button>\n' +
    '</div>');
}]);

angular.module('user/change-password.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('user/change-password.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <h3 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-exclamation-sign" style="color: #555;"></span>\n' +
    '        Change Password\n' +
    '    </h3>\n' +
    '</div>\n' +
    '<form name="passwordForm">\n' +
    '    <div class="modal-body" stop-event="touchend">\n' +
    '        <div class="row" ng-if="lowResolution && loginContext">\n' +
    '            <div class="col-sm-12">\n' +
    '                <div class="alert alert-danger alert-dismissable">\n' +
    '                    <a class="close" data-dismiss="alert" aria-label="close" title="close">×</a>\n' +
    '                    <strong>Warning!</strong> The Physical Therapy In Hand web application is optimized for a larger window. Widen your browser window if possible or use a larger tablet.\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="!isAdmin" ng-hide="prepopulated">\n' +
    '            <div class="col col-xs-12">\n' +
    '                <div class="form-group" style="margin-bottom: 42px;">\n' +
    '                    <label class="control-label">Current Password</label>\n' +
    '                    <input type="password" class="form-control" ng-model="passwordChangeRequest.oldPassword" required ihh-focus/>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="control-label">New Password</label>\n' +
    '                    <input type="{{showPassword ? \'text\' : \'password\'}}" class="form-control" ng-model="passwordChangeRequest.newPassword" required/>\n' +
    '\n' +
    '                    <input type="checkbox" class="" tabindex="1" ng-model="showPassword"/>\n' +
    '                    <label class="control-label" ng-click="showPassword = !showPassword">Show Password</label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12">\n' +
    '                <div class="form-group">\n' +
    '                    <label class="control-label">Confirm Password</label>\n' +
    '                    <input type="{{showPassword ? \'text\' : \'password\'}}" class="form-control" ng-model="passwordChangeRequest.confirmPassword" ng-disabled="showPassword" ng-required="!showPassword" />\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col col-xs-12">\n' +
    '                Your new password must be at least {{minLength}} characters long and include at least one uppercase letter, one lowercase letter, and one numeral or symbol.\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div ng-show="isClinicApp()">\n' +
    '            <div class="horz-spacer"></div>\n' +
    '            <div class="horz-spacer"></div>\n' +
    '            <div class="horz-spacer"></div>\n' +
    '            <div class="row">\n' +
    '                <div class="col col-xs-12">\n' +
    '                    <div class ="checkbox">\n' +
    '                        <label for="terms" class="control-label small checkbox-label">\n' +
    '                            <input type="checkbox" id="terms" class="" ng-model="agreeTerms"/> I agree that I will only access protected health information for patients which I have authority to access under applicable law and I agree that my use of the In Hand Health Services is subject to the Provider Terms of Service.\n' +
    '                        </label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal-footer">\n' +
    '        <button class="btn btn-primary" ng-disabled="!isFormAcceptable()" ng-click="ok()">\n' +
    '            <span class="glyphicon glyphicon-ok-sign" style=""></span>\n' +
    '            Change Password\n' +
    '        </button>\n' +
    '        <button class="btn btn-default" ng-click="cancel()">\n' +
    '            <span class="glyphicon glyphicon-remove-sign" style="color:#555;"></span>\n' +
    '            Cancel\n' +
    '        </button>\n' +
    '    </div>\n' +
    '</form>\n' +
    '');
}]);

angular.module('user/login.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('user/login.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-23 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div id="login" class="container" style="margin-top: 25px;" cg-busy="busyPromise">\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-1 col-sm-2">\n' +
    '        </div>\n' +
    '        <div class="box col-xs-10 col-sm-8">\n' +
    '            <img ng-if="getLogoUrl().length > 0" ng-src="{{getLogoUrl()}}" class="center-block img-responsive" style="max-width: 350px" alt="Physical Therapy In Hand">\n' +
    '            <p class="text-center" style="margin-top: 15px;">\n' +
    '                <strong>Welcome!</strong> Please enter your email and password to <span ng-if="isPatientApp()">manage your account</span><span ng-if="!isPatientApp()">access {{getLoginText()}}</span>.\n' +
    '            </p>\n' +
    '            <div class="row">\n' +
    '                <form>\n' +
    '                    <div ng-if="lowResolution" class="col-sm-12">\n' +
    '                        <div class="alert alert-danger alert-dismissable">\n' +
    '                            <a class="close" data-dismiss="alert" aria-label="close" title="close">×</a>\n' +
    '                            <strong>Warning!</strong> The Physical Therapy In Hand web application is optimized for a larger window. Widen your browser window if possible or use a larger tablet.\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-md-6" style="margin-top: 15px;">\n' +
    '                        <label class="sr-only">Email</label>\n' +
    '                        <div class="input-group">\n' +
    '                            <span class="input-group-addon glyphicon glyphicon-envelope" aria-hidden="true" style="color: #555;"></span>\n' +
    '                            <input type="text" class="form-control input-lg" placeholder="Email" autocapitalize="off" autocorrect="off" ng-model="credentials.username" ihh-focus="{{credentials.username.length === 0}}" style="position: initial;"/>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-12 col-md-6" style="margin-top: 15px;">\n' +
    '                        <label class="sr-only">Password</label>\n' +
    '                        <div class="input-group">\n' +
    '                            <span class="input-group-addon glyphicon glyphicon-lock" aria-hidden="true" style="color: #555;"></span>\n' +
    '                            <input type="password" class="form-control input-lg" placeholder="Password" ng-model="credentials.password" ihh-focus="{{credentials.username === storedUsername}}" style="position: initial;"/>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="col-sm-12" style="margin-top: 15px;">\n' +
    '                        <button class="btn btn-primary btn-block"  ng-class="isPatientApp() ? \'btn-sm\' : \'btn-lg\'" ng-click="login(credentials);" ng-disabled="!(credentials.password && credentials.username)">\n' +
    '                            <span class="glyphicon glyphicon-pencil"></span>\n' +
    '                            Sign In\n' +
    '                        </button>\n' +
    '                    </div>\n' +
    '                    \n' +
    '                    <div class="text-center" style="margin-top:10px;">\n' +
    '                        <p ng-if="!isPatientApp()">\n' +
    '                            By signing in, you agree to our <a ng-href="{{terms}}" target="_blank">Terms of Service</a> and <a href="https://inhandhealth.com/about/privacy.php" target="_blank">Privacy Policy</a>.<br/><a href="" ng-click="resetPassword()">Forgot your password?</a>\n' +
    '                        </p>\n' +
    '                        <p ng-if="isPatientApp()">\n' +
    '                            By signing in, you agree to <span style="white-space:nowrap">In Hand Health\'s</span> <a ng-href="{{terms}}" target="_blank">Terms of Service</a> and <a href="https://inhandhealth.com/about/privacy.php" target="_blank">Privacy Policy</a>.<br/><a href="" ng-click="resetPassword()">Forgot your password?</a>\n' +
    '                        </p>\n' +
    '                    </div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('user/manage-account.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('user/manage-account.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-15 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<ihh-navbar navbar-styles="navbar-fixed-top navbar2-fixed-top" brand="Manage Account" collapse-id="manage-account-navbar-id">\n' +
    '    <div class="navbar-form navbar-right" style="margin-bottom: 0px;">\n' +
    '        <ul class="nav navbar-nav">\n' +
    '            <li>\n' +
    '                <fieldset ng-disabled="saving">\n' +
    '                    <button type="button" class="btn btn-sm btn-info" \n' +
    '                            ng-show="!isEdit" \n' +
    '                            ng-click="changePassword()">\n' +
    '                        <span class="glyphicon glyphicon-refresh" style="margin-right: 5px;"></span>\n' +
    '                        Change Password\n' +
    '                    </button>\n' +
    '                    <button type="button" class="btn btn-sm btn-primary" \n' +
    '                            ng-show="!isEdit" \n' +
    '                            ng-click="edit()">\n' +
    '                        <span class="glyphicon glyphicon-edit" style="margin-right: 5px;"></span>\n' +
    '                        Edit\n' +
    '                    </button>\n' +
    '                    <button type="button" class="btn btn-sm btn-primary" \n' +
    '                            ng-show="isEdit" \n' +
    '                            ng-click="save()">\n' +
    '                        <span class="glyphicon glyphicon-edit" style="margin-right: 5px;"></span>\n' +
    '                        Save\n' +
    '                    </button>\n' +
    '                    <button type="button" class="btn btn-sm btn-default" \n' +
    '                            ng-show="isEdit" \n' +
    '                            ng-click="cancel()">\n' +
    '                        <span class="glyphicon glyphicon-remove-sign" style="color:#555; margin-right: 5px;"></span>\n' +
    '                        Cancel\n' +
    '                    </button>\n' +
    '                </fieldset>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '</ihh-navbar>\n' +
    '\n' +
    '<div class="double-navbar-top-body">\n' +
    '    <form cg-busy="getSelf().$promise" novalidate name="profileForm" role="form">\n' +
    '        <div ng-include="\'user/person.tpl.html\'"></div>\n' +
    '    </form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('user/person.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('user/person.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="row">\n' +
    '    <div class="col-limit-width">\n' +
    '        <div class="row">\n' +
    '            <div class="col col-sm-3 col-lg-2">\n' +
    '                <ihh-view-edit-media class="" \n' +
    '                    control-id="thumbnail" \n' +
    '                    label="Thumbnail" \n' +
    '                    is-required="false" \n' +
    '                    edit-flag="isEdit" \n' +
    '                    model="person.thumbnail" \n' +
    '                    model-edit="personTemp.thumbnail" \n' +
    '                    no-media-url="getDefaultPersonThumbnailUrl()"\n' +
    '                    kind="thumbnail"\n' +
    '                    choose-media="chooseThumbnail"\n' +
    '                    remove-media="deleteThumbnail"\n' +
    '                    get-media-url="getThumbnailUrl"\n' +
    '                    get-media-temp-url="getTempThumbnailUrl">\n' +
    '                </ihh-view-edit-media>\n' +
    '            </div>\n' +
    '            <div class="visible-xs horz-spacer"></div>\n' +
    '            <div class="visible-xs horz-spacer"></div>\n' +
    '            <div class="col col-sm-9 col-lg-10">\n' +
    '                <div class="row">\n' +
    '                    <div class="col col-sm-6">\n' +
    '                        <ihh-view-edit-text class="" \n' +
    '                            control-id="firstname" \n' +
    '                            label="First Name" \n' +
    '                            focus="isEdit"\n' +
    '                            is-required="true" \n' +
    '                            edit-flag="isEdit" \n' +
    '                            model="person.firstName" \n' +
    '                            model-edit="personTemp.firstName">\n' +
    '                        </ihh-view-edit-text>\n' +
    '                    </div>\n' +
    '                    <div class="col col-sm-6">\n' +
    '                        <ihh-view-edit-text class="" \n' +
    '                            control-id="lastname" \n' +
    '                            label="Last Name"\n' +
    '                            is-required="true" \n' +
    '                            edit-flag="isEdit" \n' +
    '                            model="person.lastName" \n' +
    '                            model-edit="personTemp.lastName">\n' +
    '                        </ihh-view-edit-text>\n' +
    '                    </div>\n' +
    '                    <div class="col col-sm-6">\n' +
    '                        <ihh-view-edit-text class="" \n' +
    '                            control-id="username" \n' +
    '                            label="Email" \n' +
    '                            secondary-label="(username)"\n' +
    '                            text-type="email" \n' +
    '                            is-required="true" \n' +
    '                            edit-flag="isEdit" \n' +
    '                            model="person.username" \n' +
    '                            model-edit="personTemp.username">\n' +
    '                        </ihh-view-edit-text>\n' +
    '                    </div>\n' +
    '                    <div class="col col-sm-6" ng-if="!suppressActive">\n' +
    '                        <ihh-view-edit-select class="" \n' +
    '                            control-id="status" \n' +
    '                            label="Status" \n' +
    '                            edit-flag="isEdit" \n' +
    '                            get="getActive" \n' +
    '                            set="setActive" \n' +
    '                            values="[true, false]" \n' +
    '                            format-value="formatActive">\n' +
    '                        </ihh-view-edit-select>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div style="font-size: small; font-style: italic;">\n' +
    '            * This is your personal thumbnail.\n' +
    '            <span ng-if="isClinicApp() || isOpsApp()">\n' +
    '                It will appear only when\n' +
    '            </span>\n' +
    '            <span ng-if="isOpsApp()">\n' +
    '                IHH\n' +
    '            </span>\n' +
    '            <span ng-if="isClinicApp()">\n' +
    '                your clinic\n' +
    '            </span>\n' +
    '            <span ng-if="isClinicApp() || isOpsApp()">\n' +
    '                hasn\'t set one for you.\n' +
    '            </span>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('user/reset-password.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('user/reset-password.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <h3 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-question-sign" style="color:#555; margin-right: 5px;"></span>\n' +
    '        Forgot Your Password\n' +
    '    </h3>\n' +
    '</div>\n' +
    '<div class="modal-body" cg-busy="savePromise" stop-event="touchend">\n' +
    '    <p>\n' +
    '        Enter the email address associated with your Physical Therapy In Hand account. We will send you a temporary password.\n' +
    '    </p>\n' +
    '    <form name="resetForm">\n' +
    '        <div class="row" style="margin: 0px;">\n' +
    '            <label class="">Email:</label>\n' +
    '            <input type="email" class="form-control" ng-model="passwordResetRequest.emailAddress" required/>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-primary" ng-disabled="!isResetFormAcceptable()" ihh-focus="{{isResetFormAcceptable() && resetForm.$pristine}}" ng-hide="passwordChangeRequest.resetToken" ng-click="sendEmail()">\n' +
    '        <span class="glyphicon glyphicon-ok-sign" style=""></span>\n' +
    '        Send Temporary Password\n' +
    '    </button>\n' +
    '    <button class="btn btn-default" ng-click="cancel()">\n' +
    '        <span class="glyphicon glyphicon-remove-sign" style="color:#555;"></span>\n' +
    '        Cancel\n' +
    '    </button>\n' +
    '</div>');
}]);

angular.module('user/resolve-person-conflict.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('user/resolve-person-conflict.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-19 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Patient or Staff record exists with different name</h4>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <p>\n' +
    '        There is already a patient or staff record in our system using email <strong>{{person.username}}</strong> with name entered as <strong>{{person.firstName}} \n' +
    '            {{person.lastName}}</strong>. You have entered <strong>{{secondaryIndividual.firstName}} {{secondaryIndividual.lastName}}</strong> as the name to be displayed{{context}}.\n' +
    '    </p>\n' +
    '    <p>\n' +
    '        If you would like to use the name already in our system, press <strong>OK</strong>.\n' +
    '    </p>\n' +
    '    <p>\n' +
    '        If you would like to use the name as you have entered it, press <strong>Change</strong>.\n' +
    '    </p>\n' +
    '    <p>\n' +
    '        If this is not the correct person, or you want to make a change, press <strong>Cancel</strong>.\n' +
    '    </p>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button type="button" class="btn btn-primary" ng-disabled="resolvePersonForm.$invalid" ng-click="chooseExisting()">OK</button>\n' +
    '    <button type="button" class="btn btn-success" ng-disabled="resolvePersonForm.$invalid" ng-click="chooseEntered()">Change</button>\n' +
    '    <button type="button" class="btn btn-default" ng-click="cancel()">Cancel</button>\n' +
    '</div>');
}]);

angular.module('utilities/modal-about.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/modal-about.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014-17 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <h4 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-exclamation-sign"></span>\n' +
    '        About\n' +
    '    </h4>\n' +
    '</div>\n' +
    '<div class="modal-body text-center">\n' +
    '    <img class="center-block img-responsive" style="max-width: 350px" ng-src="{{getLogoUrl()}}" >\n' +
    '    <p>\n' +
    '        UI Version {{version}}\n' +
    '    </p>\n' +
    '    <p>\n' +
    '        REST Version {{restVersion.implementationVersion}}\n' +
    '    </p>\n' +
    '    <p>\n' +
    '        Copyright © 2014-{{currentYear}} In Hand Health, LLC. All rights reserved.\n' +
    '    </p>\n' +
    '    <p>\n' +
    '        By signing in, you agree to our <a ng-href="{{terms}}" target="_blank">Terms of Service</a> and our <a href="https://inhandhealth.com/about/privacy.php" target="_blank">Privacy Policy</a>.\n' +
    '    </p>\n' +
    '    <p ng-if="!isPatientApp">\n' +
    '        <strong>\n' +
    '            Find support and more at \n' +
    '            <a href="https://www.inhandhealth.com" target="new">www.inhandhealth.com</a>\n' +
    '        </strong>\n' +
    '    </p>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-default" ng-click="cancel()" ihh-focus>\n' +
    '        <span class="glyphicon glyphicon-ok-sign" style="color: #555;"></span>\n' +
    '        Thanks!\n' +
    '    </button>\n' +
    '</div>');
}]);

angular.module('utilities/modal-confirm.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/modal-confirm.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <button type="button" class="close" ng-click="cancel()">\n' +
    '        <span class="glyphicon glyphicon-remove"></span>\n' +
    '    </button>\n' +
    '    <h4 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-exclamation-sign"></span>\n' +
    '        {{title ? title : \'Confirm\'}}\n' +
    '    </h4>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <p class="modal-body-message">{{message}}</p>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-danger" ng-click="ok()" ihh-focus>\n' +
    '        <span class="glyphicon glyphicon-ok-sign"></span>\n' +
    '        {{confirm}}\n' +
    '    </button>\n' +
    '    <button class="btn btn-default" ng-click="cancel()">\n' +
    '        <span class="glyphicon glyphicon-remove-sign" style="color: #555;"></span>\n' +
    '        {{deny}}\n' +
    '    </button>\n' +
    '</div>');
}]);

angular.module('utilities/modal-exercise-quick-view.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/modal-exercise-quick-view.tpl.html',
    '<!--\n' +
    'Copyright (c) 2016 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <h4 class="modal-title">\n' +
    '        Exercise Quick View\n' +
    '    </h4>\n' +
    '</div>\n' +
    '<div class="modal-body quick-view">\n' +
    '    <div class="row spacer-bottom-small">\n' +
    '        <div class="col col-xs-4 col-sm-5">\n' +
    '            <tabset justified="true" class="quickview-tabset">\n' +
    '                <tab heading="Overview">\n' +
    '                    <div ng-if="!selectedItem.overviewVideo">\n' +
    '                        Exercise has no Overview Video.\n' +
    '                    </div>\n' +
    '                    <videogular ng-if="selectedItem.overviewVideo">\n' +
    '                        <vg-media vg-src="overviewConfig.sources"></vg-media>\n' +
    '                        <vg-controls vg-autohide="config.plugins.controls.autoHide" vg-autohide-time="config.plugins.controls.autoHideTime">\n' +
    '                            <vg-play-pause-button></vg-play-pause-button>\n' +
    '                            <vg-time-display ng-show="API.isFullScreen">{{ currentTime | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                            <vg-scrub-bar ng-show="API.isFullScreen">\n' +
    '                                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n' +
    '                            </vg-scrub-bar>\n' +
    '                            <vg-time-display ng-show="API.isFullScreen">{{ timeLeft | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                            <vg-volume ng-show="API.isFullScreen">\n' +
    '                                <vg-mute-button></vg-mute-button>\n' +
    '                                <vg-volume-bar></vg-volume-bar>\n' +
    '                            </vg-volume>\n' +
    '\n' +
    '                            <ihh-fullscreen-button class="ihh-custom-videogular-button"></ihh-fullscreen-button>\n' +
    '                        </vg-controls>\n' +
    '\n' +
    '                        <vg-overlay-play></vg-overlay-play>\n' +
    '                    </videogular>\n' +
    '                </tab>\n' +
    '                <tab heading="Exercise" active="tabState.noOverview">\n' +
    '                    <div ng-if="!selectedItem.exerciseVideo">\n' +
    '                        Exercise has no Exercise Video.\n' +
    '                    </div>\n' +
    '                    <videogular ng-if="selectedItem.exerciseVideo">\n' +
    '                        <vg-media vg-src="exerciseConfig.sources"></vg-media>\n' +
    '                        <vg-controls vg-autohide="config.plugins.controls.autoHide" vg-autohide-time="config.plugins.controls.autoHideTime">\n' +
    '                            <vg-play-pause-button></vg-play-pause-button>\n' +
    '                            <vg-time-display ng-show="API.isFullScreen">{{ currentTime | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                            <vg-scrub-bar ng-show="API.isFullScreen">\n' +
    '                                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n' +
    '                            </vg-scrub-bar>\n' +
    '                            <vg-time-display ng-show="API.isFullScreen">{{ timeLeft | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                            <vg-volume ng-show="API.isFullScreen">\n' +
    '                                <vg-mute-button></vg-mute-button>\n' +
    '                                <vg-volume-bar></vg-volume-bar>\n' +
    '                            </vg-volume>\n' +
    '\n' +
    '                            <ihh-fullscreen-button class="ihh-custom-videogular-button"></ihh-fullscreen-button>\n' +
    '                        </vg-controls>\n' +
    '\n' +
    '                        <vg-overlay-play></vg-overlay-play>\n' +
    '                    </videogular>\n' +
    '                </tab>\n' +
    '            </tabset>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col col-xs-7 col-sm-6">\n' +
    '            <div class="row">\n' +
    '                <ihh-view-edit-text\n' +
    '                    control-id="name" \n' +
    '                    label="Name" \n' +
    '                    focus="isEdit" \n' +
    '                    is-required="true" \n' +
    '                    edit-flag="false" \n' +
    '                    model="selectedItem.name">\n' +
    '                </ihh-view-edit-text>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row">\n' +
    '                <ihh-view-edit-text\n' +
    '                    control-id="title" \n' +
    '                    label="Description" \n' +
    '                    is-required="true" \n' +
    '                    edit-flag="false" \n' +
    '                    model="selectedItem.title" >\n' +
    '                </ihh-view-edit-text>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col col-xs-1"></div>\n' +
    '    </div>\n' +
    '    \n' +
    '    <div class="row">\n' +
    '        <div class="col col-xs-11">\n' +
    '            <ihh-view-edit-textarea\n' +
    '                control-id="instructions" \n' +
    '                label="Instructions" \n' +
    '                is-required="true" \n' +
    '                edit-flag="false" \n' +
    '                model="selectedItem.instructions">\n' +
    '            </ihh-view-edit-textarea>\n' +
    '        </div>\n' +
    '        <div class="col col-xs-1"></div>\n' +
    '    </div>\n' +
    '    \n' +
    '    <div class="row">\n' +
    '        <div class="col col-xs-11">\n' +
    '            <ihh-view-edit-textarea\n' +
    '                control-id="cuesAndTips" \n' +
    '                label="Cues & Tips" \n' +
    '                is-required="true" \n' +
    '                edit-flag="false" \n' +
    '                model="selectedItem.cuesAndTips">\n' +
    '            </ihh-view-edit-textarea>\n' +
    '        </div>\n' +
    '        <div class="col col-xs-1"></div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-footer">\n' +
    '    <div class="btn-group dropup" ng-show="validTargets.length > 1">\n' +
    '        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n' +
    '            Add ... <span class="caret"></span>\n' +
    '        </button>\n' +
    '        <ul class="dropdown-menu">\n' +
    '            <li ng-repeat="target in validTargets track by $index">\n' +
    '                <a ng-click="addExercise($index, target)">\n' +
    '                    {{target.title || target.name}}\n' +
    '                </a>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '    \n' +
    '    <div class="btn-group" ng-show="validTargets.length === 1">\n' +
    '        <button type="button" class="btn btn-default dropdown-toggle" ng-click="addExercise(0, validTargets)">\n' +
    '            Add\n' +
    '        </button>\n' +
    '    </div>\n' +
    '    <button class="btn btn-default" ng-click="cancel()">Close</button>\n' +
    '</div>  ');
}]);

angular.module('utilities/modal-notify.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/modal-notify.tpl.html',
    '<!--\n' +
    'Copyright (c) 2016 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <button type="button" class="close" ng-click="ok()">\n' +
    '        <span class="glyphicon glyphicon-remove"></span>\n' +
    '    </button>\n' +
    '    <h4 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-exclamation-sign"></span>\n' +
    '        {{title ? title : \'Notice\'}}\n' +
    '    </h4>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <p class="modal-body-message">{{message}}</p>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-primary" ng-click="ok()" ihh-focus>\n' +
    '        <span class="glyphicon glyphicon-ok-sign"></span>\n' +
    '        {{confirm ? confirm : \'Continue\'}}\n' +
    '    </button>\n' +
    '</div>');
}]);

angular.module('utilities/modal-text-input.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/modal-text-input.tpl.html',
    '<!--\n' +
    'Copyright (c) 2025 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <button type="button" class="close" ng-click="cancel()">\n' +
    '        <span class="glyphicon glyphicon-remove"></span>\n' +
    '    </button>\n' +
    '    <h4 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-pencil"></span>\n' +
    '        {{title}}\n' +
    '    </h4>\n' +
    '</div>\n' +
    '<div style="padding: 15px;">\n' +
    '    <p class="modal-body-message" ng-if="message">{{message}}</p>\n' +
    '    <textarea class="form-control" \n' +
    '              ng-model="inputValue" \n' +
    '              rows="4" \n' +
    '              ihh-focus\n' +
    '              placeholder="{{placeholder}}"\n' +
    '              style="margin: 0;"></textarea>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-primary" ng-click="ok()" ng-disabled="!inputValue">\n' +
    '        <span class="glyphicon glyphicon-ok-sign"></span>\n' +
    '        Save\n' +
    '    </button>\n' +
    '    <button class="btn btn-default" ng-click="cancel()">\n' +
    '        <span class="glyphicon glyphicon-remove-sign" style="color: #555;"></span>\n' +
    '        Cancel\n' +
    '    </button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('utilities/modal-wait.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/modal-wait.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-header">\n' +
    '    <h3 class="modal-title">\n' +
    '        <span class="glyphicon glyphicon-exclamation-sign"></span>\n' +
    '    {{title}}\n' +
    '    </h3>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <span class="modal-body-message">{{message}}</span>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-default" ng-click="cancel()" ihh-focus>\n' +
    '        <span class="glyphicon glyphicon-ok-sign" style="color: #555;"></span>\n' +
    '        {{buttonText}}\n' +
    '    </button>\n' +
    '</div>');
}]);

angular.module('utilities/patient-login-wait.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/patient-login-wait.tpl.html',
    '<!--\n' +
    'Copyright (c) 2016 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="text-center">\n' +
    '    <div class="cg-busy-default-sign">\n' +
    '\n' +
    '        <div class="cg-busy-default-spinner">\n' +
    '           <div class="bar1"></div>\n' +
    '           <div class="bar2"></div>\n' +
    '           <div class="bar3"></div>\n' +
    '           <div class="bar4"></div>\n' +
    '           <div class="bar5"></div>\n' +
    '           <div class="bar6"></div>\n' +
    '           <div class="bar7"></div>\n' +
    '           <div class="bar8"></div>\n' +
    '           <div class="bar9"></div>\n' +
    '           <div class="bar10"></div>\n' +
    '           <div class="bar11"></div>\n' +
    '           <div class="bar12"></div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="cg-busy-default-text ng-binding">Please Wait...</div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('utilities/ptih-loading.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/ptih-loading.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-body text-center ihh-loading">\n' +
    '    <img ng-src="{{getCommonHost()}}/assets/ptih-loading-logo.gif" class="wait-indicator-bg">\n' +
    '</div>');
}]);

angular.module('utilities/ptih-login-wait.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('utilities/ptih-login-wait.tpl.html',
    '<!--\n' +
    'Copyright (c) 2014 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="modal-body ihh-loading">\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-7 hidden-xs">\n' +
    '            <img ng-src="/assets/ptih-login-wait.jpg" >\n' +
    '        </div>\n' +
    '        <div class="col-sm-5 col-xs-12">\n' +
    '            <p style="font-family: sans-serif; font-size: 16px; text-align: center; font-style: italic; margin-top: 25px; margin-bottom: 6px;">\n' +
    '                Please wait...\n' +
    '            </p>\n' +
    '            <p style="font-family: sans-serif; font-size: 20px; text-align: center;">\n' +
    '                We are preparing\n' +
    '                <br>\n' +
    '                your workspace.\n' +
    '            </p>\n' +
    '            <img ng-src="{{getCommonHost()}}/assets/ptih-loading-logo.gif" class="center-block" alt="Physical Therapy In Hand">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('view-edit/view-edit-currency.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-currency.tpl.html',
    '<!--\n' +
    'Copyright (c) 2020 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="form-group" ng-show="!editFlag">\n' +
    '    <label>{{label}}</label><span ng-if="secondaryLabel"> {{secondaryLabel}}</span>\n' +
    '    <div class="form-control-static" ng-style="inlineStyle ? {\'display\': \'inline-block\'} : {}">{{isSet(model) ? (model | currency : symbol : fractionSize) : naText}}</div>\n' +
    '</div>\n' +
    '<div ng-class="{\'form-group\': !hideLabel, \'required\': isRequired}" ng-show="editFlag">\n' +
    '    <label for="{{controlId}}" ng-class="hideLabel ? \'hidden\' : \'control-label\'">{{label}}<span class="control-secondary-label" ng-if="secondaryLabel"> {{secondaryLabel}}</span></label>\n' +
    '    <span ng-if="helpText && !helpSymbol" class="help-text" >{{helpText}}</span>\n' +
    '    <button ng-if="helpText && helpSymbol" type="button" popover="{{helpText}}" popover-trigger="mouseenter" class="btn btn-xs btn-invis">\n' +
    '        <span class="glyphicon" ng-class="helpSymbol" title="{{helpText}}"></span>\n' +
    '    </button>\n' +
    '    \n' +
    '    <input id="{{controlId}}" type="number" min="{{numberMin}}" max="{{numberMax}}" ng-required="isRequired && editFlag" class="form-control" ng-model="modelEdit" ihh-focus="{{focus ? focus : \'false\'}}"\n' +
    '           ui-options="{clearOnBlur: false}">\n' +
    '</div>\n' +
    '');
}]);

angular.module('view-edit/view-edit-date.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-date.tpl.html',
    '<div class="form-group" ng-show="!vm.isEdit">\n' +
    '    <label class="control-label">{{vm.label}}</label>\n' +
    '    <div class="form-control-static" ng-if="!vm.isEdit && !vm.isModelGetterSetter">\n' +
    '        {{vm.model ? (vm.model | date : vm.displayFormat) : \'N/A\'}}\n' +
    '    </div>\n' +
    '    <div class="form-control-static" ng-if="!vm.isEdit && vm.isModelGetterSetter">\n' +
    '        {{vm.model() ? (vm.model() | date : vm.displayFormat) : \'N/A\'}}\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div ng-class="(vm.isRequired ? \'form-group required\' : \'form-group\')" ng-show="vm.isEdit">\n' +
    '    <label class="control-label">{{vm.label}}</label>\n' +
    '    <div ng-class="vm.showTime ? \'btn-group vcenter-container\' : \'\'">\n' +
    '        <div ng-class="vm.showTime ? \'btn\': \'\'">\n' +
    '            <div class="input-group calendar-dropdown">\n' +
    '                <input id="{{vm.controlId}}"\n' +
    '                       type="text" \n' +
    '                       class="form-control" \n' +
    '                       placeholder="mm/dd/yyyy (not required)"\n' +
    '                       show-button-bar="false"\n' +
    '                       show-weeks="false"\n' +
    '                       datepicker-popup="MM/dd/yyyy" \n' +
    '                       ng-model="vm.modelEdit" \n' +
    '                       ng-model-options="vm.isModelGetterSetter ? { getterSetter: true } : {}"\n' +
    '                       is-open="isOpen" \n' +
    '                       init-date="vm.initDateValue"\n' +
    '                       min-date="vm.minDateString" \n' +
    '                       max-date="vm.maxDateString" \n' +
    '                       ng-required="vm.isRequired && vm.isEdit" \n' +
    '                       close-text="Close"\n' +
    '                       autocomplete="off">\n' +
    '                <span class="input-group-btn">\n' +
    '                    <button type="button" class="btn btn-default" ng-click="vm.toggleCalendar($event, \'isOpen\')">\n' +
    '                        <i class="glyphicon glyphicon-calendar glyphicon-bg-light"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '        </div>    \n' +
    '        <div ng-if="vm.showTime" class="btn">\n' +
    '            <timepicker class="glyphicon-bg-light" ng-model="vm.timeEdit" ng-change="vm.timeChanged()"></timepicker>\n' +
    '        </div>\n' +
    '        <div ng-if="vm.showTime" class="btn">\n' +
    '            <button class="btn btn-info" ng-click="vm.clearTime()">{{vm.i18n.clearButtonLabel}}</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('view-edit/view-edit-media.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-media.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div ng-if="kind === \'thumbnail\'">\n' +
    '    <div ng-show="!editFlag">\n' +
    '        <div class="view-edit-thumbnails-container">\n' +
    '            <img ng-src="{{getMediaUrl()}}" class="img-rounded img-responsive view-edit-thumbnails">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-show="editFlag">\n' +
    '        <div class="view-edit-thumbnails-container">\n' +
    '            <img ng-src="{{getMediaTempUrl()}}" class="img-rounded img-responsive view-edit-thumbnails">\n' +
    '            <div class="btn-group-up-right">\n' +
    '                <button type="button" class="btn btn-xs btn-info btn-vertical-stack" ng-click="chooseMedia()">\n' +
    '                    <span class="glyphicon glyphicon-plus"></span>\n' +
    '                </button>\n' +
    '                <button type="button" class="btn btn-xs btn-danger btn-vertical-stack" ng-show="modelEdit" ng-click="removeMedia()">\n' +
    '                    <span class="glyphicon glyphicon-trash"></span>\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div ng-if="kind === \'video\'">\n' +
    '    <label>{{label}} </label>\n' +
    '    <div ng-class="{\'embed-responsive\': isResponsive, \'embed-responsive-square\': isResponsive, \'video-aspect-fill\': isVideoAspectFill()}" ng-show="!editFlag">\n' +
    '        \n' +
    '        <videogular ng-if="model">\n' +
    '            <vg-media vg-src="viewConfig.sources"></vg-media>\n' +
    '            <vg-controls vg-autohide="config.plugins.controls.autoHide" vg-autohide-time="config.plugins.controls.autoHideTime">\n' +
    '                <vg-play-pause-button></vg-play-pause-button>\n' +
    '                <vg-time-display ng-show="API.isFullScreen">{{ currentTime | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                <vg-scrub-bar ng-show="API.isFullScreen">\n' +
    '                    <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n' +
    '                </vg-scrub-bar>\n' +
    '                <vg-time-display ng-show="API.isFullScreen">{{ timeLeft | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                <vg-volume ng-show="API.isFullScreen">\n' +
    '                    <vg-mute-button></vg-mute-button>\n' +
    '                    <vg-volume-bar></vg-volume-bar>\n' +
    '                </vg-volume>\n' +
    '\n' +
    '                <ihh-fullscreen-button class="ihh-custom-videogular-button"></ihh-fullscreen-button>\n' +
    '            </vg-controls>\n' +
    '\n' +
    '            <vg-overlay-play></vg-overlay-play>\n' +
    '        </videogular>\n' +
    '        \n' +
    '        <img ng-src="{{noMediaUrl}}" style="width: 100%" ng-show="!model">\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="embed-responsive embed-responsive-square" ng-class="{\'video-aspect-fill\': isVideoAspectFill()}" ng-show="editFlag">\n' +
    '        \n' +
    '        <videogular ng-if="modelEdit">\n' +
    '            <vg-media vg-src="editConfig.sources"></vg-media>\n' +
    '            <vg-controls vg-autohide="config.plugins.controls.autoHide" vg-autohide-time="config.plugins.controls.autoHideTime">\n' +
    '                <vg-play-pause-button></vg-play-pause-button>\n' +
    '                <vg-time-display ng-show="API.isFullScreen">{{ currentTime | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                <vg-scrub-bar ng-show="API.isFullScreen">\n' +
    '                    <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n' +
    '                </vg-scrub-bar>\n' +
    '                <vg-time-display ng-show="API.isFullScreen">{{ timeLeft | date:\'mm:ss\' }}</vg-time-display>\n' +
    '                <vg-volume ng-show="API.isFullScreen">\n' +
    '                    <vg-mute-button></vg-mute-button>\n' +
    '                    <vg-volume-bar></vg-volume-bar>\n' +
    '                </vg-volume>\n' +
    '\n' +
    '                <ihh-fullscreen-button class="ihh-custom-videogular-button"></ihh-fullscreen-button>\n' +
    '            </vg-controls>\n' +
    '\n' +
    '            <vg-overlay-play></vg-overlay-play>\n' +
    '        </videogular>\n' +
    '        \n' +
    '        <img ng-src="{{noMediaUrl}}" style="width: 100%" ng-show="!modelEdit">\n' +
    '        <div class="btn-group-up-right">\n' +
    '            <button type="button" class="btn btn-xs btn-info btn-vertical-stack" ng-click="chooseMedia()">\n' +
    '                <span class="glyphicon glyphicon-plus"></span>\n' +
    '            </button>\n' +
    '            <button type="button" class="btn btn-xs btn-danger btn-vertical-stack" ng-show="modelEdit" ng-click="removeMedia()">\n' +
    '                <span class="glyphicon glyphicon-trash"></span>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('view-edit/view-edit-person.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-person.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="row">\n' +
    '    <div class="col-limit-width">\n' +
    '        <div class="row">\n' +
    '            <div class="col col-sm-3 col-lg-2">\n' +
    '                <ihh-view-edit-media class="" \n' +
    '                    control-id="thumbnail" \n' +
    '                    label="Thumbnail" \n' +
    '                    is-required="false" \n' +
    '                    edit-flag="editFlag" \n' +
    '                    model="staff.thumbnail" \n' +
    '                    model-edit="thumbnailContainer.thumbnail" \n' +
    '                    no-media-url="getDefaultPersonThumbnailUrl()"\n' +
    '                    kind="thumbnail"\n' +
    '                    choose-media="chooseThumbnail"\n' +
    '                    remove-media="deleteThumbnail"\n' +
    '                    get-media-url="getThumbnailUrl"\n' +
    '                    get-media-temp-url="getThumbnailUrl">\n' +
    '                </ihh-view-edit-media>\n' +
    '            </div>\n' +
    '            <div class="visible-xs horz-spacer"></div>\n' +
    '            <div class="visible-xs horz-spacer"></div>\n' +
    '            <div class="col col-sm-9 col-lg-10">\n' +
    '                <div class="row">\n' +
    '                    <ihh-view-edit-text\n' +
    '                        class="col col-sm-6"\n' +
    '                        control-id="firstname"\n' +
    '                        label="First Name"\n' +
    '                        is-required="true"\n' +
    '                        focus="editFlag"\n' +
    '                        edit-flag="editFlag"\n' +
    '                        model="person.firstName"\n' +
    '                        model-edit="personEdit.firstName">\n' +
    '                    </ihh-view-edit-text>\n' +
    '                    \n' +
    '                    <ihh-view-edit-text\n' +
    '                        class="col col-sm-6"\n' +
    '                        control-id="lastname"\n' +
    '                        label="Last Name"\n' +
    '                        is-required="true"\n' +
    '                        edit-flag="editFlag"\n' +
    '                        model="person.lastName"\n' +
    '                        model-edit="personEdit.lastName">\n' +
    '                    </ihh-view-edit-text>\n' +
    '                    \n' +
    '                    <ihh-view-edit-text\n' +
    '                        class="col col-sm-6"\n' +
    '                        control-id="username"\n' +
    '                        label="Email"\n' +
    '                        secondary-label="(username)"\n' +
    '                        is-required="true"\n' +
    '                        edit-flag="editFlag"\n' +
    '                        model="person.person.username"\n' +
    '                        model-edit="personEdit.person.username"\n' +
    '                        text-type="email">\n' +
    '                    </ihh-view-edit-text>\n' +
    '                    \n' +
    '                    <ihh-view-edit-select\n' +
    '                        class="col col-sm-6"\n' +
    '                        control-id="status"\n' +
    '                        label="Status"\n' +
    '                        edit-flag="editFlag"\n' +
    '                        get="getActive"\n' +
    '                        set="setActive"\n' +
    '                        values="[true, false]"\n' +
    '                        format-value="formatActive"\n' +
    '                        ng-if="showActive">\n' +
    '                    </ihh-view-edit-select>\n' +
    '                    \n' +
    '                    <ihh-view-edit-text\n' +
    '                        class="col col-sm-6"\n' +
    '                        control-id="logged-in"\n' +
    '                        label="Logged In"\n' +
    '                        edit-flag="false"\n' +
    '                        model="(person.lastLogin|date:\'medium\') || \'Never Logged In\'"\n' +
    '                        model-edit="personEdit.lastLogin">\n' +
    '                    </ihh-view-edit-text>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="roleType">\n' +
    '            <div class="col col-sm-3 col-lg-2"></div>\n' +
    '            <div class="col col-sm-3 col-lg-2">\n' +
    '                <label ng-class="{required: true}">Roles</label><a href ng-click="toggleAllRoles()" ng-show="editFlag" style="margin-left: 5px;">Set All</a>\n' +
    '                <div ng-repeat="role in roles">\n' +
    '                    <label style="font-weight: normal;">\n' +
    '                        <input type="checkbox" \n' +
    '                               ng-model="rolesGetterSetter(role.value)" \n' +
    '                               ng-model-options="{getterSetter: true}"\n' +
    '                               ihh-valid-if="{{angular.isDefined(personEdit.roles) && personEdit.roles.length > 0}}"\n' +
    '                               ng-disabled="!editFlag">\n' +
    '                        {{role.label}}\n' +
    '                    </label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('view-edit/view-edit-select.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-select.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015-19 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="form-group" ng-show="!editFlag">\n' +
    '    <label>{{label}}</label>\n' +
    '    <div class="form-control-static" ng-style="inlineStyle ? {\'display\': \'inline-block\'} : {}">{{getValueString(get(containingModel, containingModelDefault))}}</div>\n' +
    '</div>\n' +
    '<div class="form-group form-group-select" ng-show="editFlag">\n' +
    '    <label for="{{controlId}}">{{label}}</label>\n' +
    '    <div class="form-control form-control-btn btn-group" dropdown id="{{controlId}}" style="padding: 0px">\n' +
    '        <button type="button" class="btn btn-primary dropdown-toggle" dropdown-toggle ng-disabled="disabledIfExp">{{getValueString(get(containingModel, containingModelDefault))}} <span class="caret"></span></button>\n' +
    '        <ul class="dropdown-menu" role="menu">\n' +
    '            <li ng-if="values.length > 0" ng-repeat="value in values" ng-click="set(value, containingModel, containingForm);closeDropdown($event);"><a href="">{{getValueString(value)}}</a></li>\n' +
    '            <li ng-if="values.length === 0 && valuesDefaults.length > 0" ng-repeat="value in valuesDefaults" ng-click="set(value, containingModel, containingForm);closeDropdown($event);"><a href="">{{getValueString(value)}}</a></li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('view-edit/view-edit-tags.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-tags.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '\n' +
    '<div class="row spacer-bottom-very-small">\n' +
    '    <label class="col-xs-4 spacer-bottom-none">\n' +
    '        {{label}} \n' +
    '    </label>\n' +
    '    <div ng-show="!editFlag" ng-if="(model | filter : {name: kind}).length > 0" ng-repeat="tag in model| filter : {name : kind} | orderBy : \'value\'">\n' +
    '        <div class="{{!$first ? \'col-xs-offset-4\' : \'\'}} col-xs-8">\n' +
    '            {{tag.value}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-show="!editFlag" ng-if="((model ? model : []) | filter : {name: kind}).length === 0">\n' +
    '        <div class="col-xs-8">\n' +
    '            None\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div ng-show="editFlag">\n' +
    '        <div ng-repeat="tag in modelEdit| filter : {name: kind} | orderBy : \'value\'">\n' +
    '            <div class="{{!$first ? \'col-xs-offset-4\' : \'\'}} col-xs-8">\n' +
    '                <button type="button" class="btn btn-default btn-wrap" ng-click="removeTag(tag)">\n' +
    '                    {{tag.value}}\n' +
    '                    <span class="glyphicon glyphicon-remove"></span>\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="btn-group {{!!(modelEdit | filter : {name: kind}) ? \'col-xs-offset-4\' : \'\'}} col-xs-8" dropdown>\n' +
    '            <button type="button" class="btn btn-primary dropdown-toggle" dropdown-toggle>\n' +
    '                Add {{label}} <span class="caret"></span>\n' +
    '            </button>\n' +
    '            <ul class="dropdown-menu" role="menu">\n' +
    '                <li>\n' +
    '                    <a href ng-repeat="tag in tags track by $index | orderBy : \'value\'" ng-click="addTag(tag);closeDropdown($event);">\n' +
    '                        {{tag.value}}\n' +
    '                    </a>\n' +
    '                    <a href ng-hide="(tags ? tags : []).length > 0">\n' +
    '                        None\n' +
    '                    </a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('view-edit/view-edit-text.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-text.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="form-group" ng-show="!editFlag">\n' +
    '    <label>{{label}}</label><span ng-if="secondaryLabel"> {{secondaryLabel}}</span>\n' +
    '    <div class="form-control-static" ng-style="inlineStyle ? {\'display\': \'inline-block\'} : {}">\n' +
    '        <div ng-if="!viewFormatFn">{{isSet(model) ? (model | maskfilter : mask) : (modelDefault ? modelDefault : naText)}}</div>\n' +
    '        <div ng-if="viewFormatFn">{{viewFormatFn(model)}}</div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div ng-class="{\'form-group\': !hideLabel, \'required\': isRequired}" ng-show="editFlag">\n' +
    '    <label for="{{controlId}}" ng-class="hideLabel ? \'hidden\' : \'control-label\'">{{label}}<span class="control-secondary-label" ng-if="secondaryLabel"> {{secondaryLabel}}</span></label>\n' +
    '    <span ng-if="helpText && !helpSymbol" class="help-text" >{{helpText}}</span>\n' +
    '    <button ng-if="helpText && helpSymbol" type="button" popover="{{helpText}}" popover-trigger="mouseenter" class="btn btn-xs btn-invis">\n' +
    '        <span class="glyphicon" ng-class="helpSymbol" title="{{helpText}}"></span>\n' +
    '    </button>\n' +
    '    \n' +
    '    <input id="{{controlId}}" type="{{textType}}" min="{{numberMin}}" max="{{numberMax}}" ng-required="isRequired && editFlag" class="form-control" ng-model="modelEdit" ihh-focus="{{focus ? focus : \'false\'}}"\n' +
    '           ihh-valid-if="{{angular.isUndefined(validIfExp) ? \'true\' : validIfExp}}"\n' +
    '           ng-disabled="disabledIfExp" ng-pattern="pattern" placeholder="{{placeholder}}" ui-mask="{{mask}}" ui-options="{clearOnBlur: false}">\n' +
    '</div>\n' +
    '');
}]);

angular.module('view-edit/view-edit-textarea.tpl.html', []).run(['$templateCache', function($templateCache) {
  $templateCache.put('view-edit/view-edit-textarea.tpl.html',
    '<!--\n' +
    'Copyright (c) 2015 In Hand Health.\n' +
    'All rights reserved.\n' +
    '-->\n' +
    '<div class="form-group" ng-show="!editFlag">\n' +
    '    <label>{{label}}</label>\n' +
    '    <div btf-markdown="model ? model : (modelDefault ? modelDefault : \'N/A\')"></div>\n' +
    '</div>\n' +
    '<div class="form-group" ng-class="{required: isRequired}" ng-show="editFlag">\n' +
    '    <label for="{{controlId}}" class="control-label">{{label}}</label>\n' +
    '    <textarea id="{{controlId}}" \n' +
    '              rows="{{rows ? rows : \'2\'}}" \n' +
    '              class="form-control" \n' +
    '              style="resize: vertical;"\n' +
    '              ihh-focus="{{focus ? focus : \'false\'}}"\n' +
    '              ng-required="isRequired && editFlag" \n' +
    '              ng-model="modelEdit"\n' +
    '              ng-change="onChange()"></textarea>\n' +
    '</div>\n' +
    '');
}]);
